export function CodeIcon({ className }: { className?: string }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/code' fill='url(#purpleGradient)'>
        <path
          id='Vector'
          d='M17.0306 13.7194C17.1004 13.789 17.1557 13.8717 17.1934 13.9628C17.2312 14.0538 17.2506 14.1514 17.2506 14.25C17.2506 14.3486 17.2312 14.4462 17.1934 14.5372C17.1557 14.6283 17.1004 14.711 17.0306 14.7806L14.7806 17.0306C14.6399 17.1714 14.449 17.2504 14.25 17.2504C14.051 17.2504 13.8601 17.1714 13.7194 17.0306C13.5786 16.8899 13.4996 16.699 13.4996 16.5C13.4996 16.301 13.5786 16.1101 13.7194 15.9694L15.4397 14.25L13.7194 12.5306C13.5786 12.3899 13.4996 12.199 13.4996 12C13.4996 11.801 13.5786 11.6101 13.7194 11.4694C13.8601 11.3286 14.051 11.2496 14.25 11.2496C14.449 11.2496 14.6399 11.3286 14.7806 11.4694L17.0306 13.7194ZM10.2806 11.4694C10.211 11.3996 10.1283 11.3443 10.0372 11.3066C9.94616 11.2688 9.84856 11.2494 9.75 11.2494C9.65144 11.2494 9.55384 11.2688 9.46279 11.3066C9.37175 11.3443 9.28903 11.3996 9.21937 11.4694L6.96937 13.7194C6.89964 13.789 6.84432 13.8717 6.80658 13.9628C6.76884 14.0538 6.74941 14.1514 6.74941 14.25C6.74941 14.3486 6.76884 14.4462 6.80658 14.5372C6.84432 14.6283 6.89964 14.711 6.96937 14.7806L9.21937 17.0306C9.28906 17.1003 9.37178 17.1556 9.46283 17.1933C9.55387 17.231 9.65145 17.2504 9.75 17.2504C9.84855 17.2504 9.94613 17.231 10.0372 17.1933C10.1282 17.1556 10.2109 17.1003 10.2806 17.0306C10.3503 16.9609 10.4056 16.8782 10.4433 16.7872C10.481 16.6961 10.5004 16.5985 10.5004 16.5C10.5004 16.4015 10.481 16.3039 10.4433 16.2128C10.4056 16.1218 10.3503 16.0391 10.2806 15.9694L8.56031 14.25L10.2806 12.5306C10.3504 12.461 10.4057 12.3783 10.4434 12.2872C10.4812 12.1962 10.5006 12.0986 10.5006 12C10.5006 11.9014 10.4812 11.8038 10.4434 11.7128C10.4057 11.6217 10.3504 11.539 10.2806 11.4694ZM20.25 8.25V20.25C20.25 20.6478 20.092 21.0294 19.8107 21.3107C19.5294 21.592 19.1478 21.75 18.75 21.75H5.25C4.85218 21.75 4.47064 21.592 4.18934 21.3107C3.90804 21.0294 3.75 20.6478 3.75 20.25V3.75C3.75 3.35218 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25H14.25C14.3485 2.24992 14.4461 2.26926 14.5371 2.3069C14.6282 2.34454 14.7109 2.39975 14.7806 2.46938L20.0306 7.71938C20.1003 7.78908 20.1555 7.87182 20.1931 7.96286C20.2307 8.05391 20.2501 8.15148 20.25 8.25ZM15 7.5H17.6897L15 4.81031V7.5ZM18.75 20.25V9H14.25C14.0511 9 13.8603 8.92098 13.7197 8.78033C13.579 8.63968 13.5 8.44891 13.5 8.25V3.75H5.25V20.25H18.75Z'
        />
      </g>
    </svg>
  )
}

export function TestIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/lab' fill='url(#purpleGradient)'>
        <path
          id='Vector'
          d='M20.7835 18.7284L15 9.08625V3.75H15.75C15.9489 3.75 16.1397 3.67098 16.2804 3.53033C16.421 3.38968 16.5 3.19891 16.5 3C16.5 2.80109 16.421 2.61032 16.2804 2.46967C16.1397 2.32902 15.9489 2.25 15.75 2.25H8.25002C8.05111 2.25 7.86034 2.32902 7.71969 2.46967C7.57904 2.61032 7.50002 2.80109 7.50002 3C7.50002 3.19891 7.57904 3.38968 7.71969 3.53033C7.86034 3.67098 8.05111 3.75 8.25002 3.75H9.00002V9.08625L3.21658 18.7284C3.08018 18.9558 3.0065 19.2154 3.00306 19.4805C2.99961 19.7457 3.06652 20.007 3.19697 20.2379C3.32741 20.4688 3.51673 20.6609 3.74563 20.7948C3.97454 20.9287 4.23484 20.9995 4.50002 21H19.5C19.7654 21 20.0261 20.9295 20.2554 20.7959C20.4847 20.6622 20.6744 20.4701 20.8052 20.2391C20.936 20.0081 21.0031 19.7466 20.9998 19.4812C20.9965 19.2158 20.9228 18.9561 20.7863 18.7284H20.7835ZM10.3931 9.67969C10.4633 9.56342 10.5003 9.43016 10.5 9.29437V3.75H13.5V9.29437C13.4998 9.43016 13.5368 9.56342 13.6069 9.67969L17.19 15.6562C16.065 15.8784 14.4647 15.7847 12.3385 14.7084C10.8469 13.9537 9.42752 13.5534 8.09908 13.5075L10.3931 9.67969ZM4.50002 19.5L7.17565 15.0394C8.51158 14.8763 10.0172 15.2128 11.6588 16.0444C13.44 16.9453 14.94 17.2519 16.1588 17.2519C16.7786 17.2546 17.3957 17.1694 17.9916 16.9988L19.5 19.5H4.50002Z'
        />
      </g>
    </svg>
  )
}

export function DataIcon() {
  return (
    <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/data' fill='url(#purpleGradient)'>
        <path d='M9 0.25C3.95344 0.25 0 2.55625 0 5.5V14.5C0 17.4438 3.95344 19.75 9 19.75C14.0466 19.75 18 17.4438 18 14.5V5.5C18 2.55625 14.0466 0.25 9 0.25ZM16.5 10C16.5 10.9019 15.7612 11.8216 14.4741 12.5238C13.0247 13.3141 11.0803 13.75 9 13.75C6.91969 13.75 4.97531 13.3141 3.52594 12.5238C2.23875 11.8216 1.5 10.9019 1.5 10V8.44C3.09938 9.84625 5.83406 10.75 9 10.75C12.1659 10.75 14.9006 9.8425 16.5 8.44V10ZM3.52594 2.97625C4.97531 2.18594 6.91969 1.75 9 1.75C11.0803 1.75 13.0247 2.18594 14.4741 2.97625C15.7612 3.67844 16.5 4.59812 16.5 5.5C16.5 6.40188 15.7612 7.32156 14.4741 8.02375C13.0247 8.81406 11.0803 9.25 9 9.25C6.91969 9.25 4.97531 8.81406 3.52594 8.02375C2.23875 7.32156 1.5 6.40188 1.5 5.5C1.5 4.59812 2.23875 3.67844 3.52594 2.97625ZM14.4741 17.0238C13.0247 17.8141 11.0803 18.25 9 18.25C6.91969 18.25 4.97531 17.8141 3.52594 17.0238C2.23875 16.3216 1.5 15.4019 1.5 14.5V12.94C3.09938 14.3463 5.83406 15.25 9 15.25C12.1659 15.25 14.9006 14.3425 16.5 12.94V14.5C16.5 15.4019 15.7612 16.3216 14.4741 17.0238Z' />
      </g>
    </svg>
  )
}

export function DiagramIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/system' fill='url(#purpleGradient)'>
        <path
          id='Vector'
          d='M15 10.5H19.5C19.8978 10.5 20.2794 10.342 20.5607 10.0607C20.842 9.77936 21 9.39782 21 9V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H15C14.6022 3 14.2206 3.15804 13.9393 3.43934C13.658 3.72064 13.5 4.10218 13.5 4.5V6H12C11.4033 6 10.831 6.23705 10.409 6.65901C9.98705 7.08097 9.75 7.65326 9.75 8.25V11.25H6.75V10.5C6.75 10.1022 6.59196 9.72064 6.31066 9.43934C6.02936 9.15804 5.64782 9 5.25 9H2.25C1.85218 9 1.47064 9.15804 1.18934 9.43934C0.908035 9.72064 0.75 10.1022 0.75 10.5V13.5C0.75 13.8978 0.908035 14.2794 1.18934 14.5607C1.47064 14.842 1.85218 15 2.25 15H5.25C5.64782 15 6.02936 14.842 6.31066 14.5607C6.59196 14.2794 6.75 13.8978 6.75 13.5V12.75H9.75V15.75C9.75 16.3467 9.98705 16.919 10.409 17.341C10.831 17.7629 11.4033 18 12 18H13.5V19.5C13.5 19.8978 13.658 20.2794 13.9393 20.5607C14.2206 20.842 14.6022 21 15 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15C21 14.6022 20.842 14.2206 20.5607 13.9393C20.2794 13.658 19.8978 13.5 19.5 13.5H15C14.6022 13.5 14.2206 13.658 13.9393 13.9393C13.658 14.2206 13.5 14.6022 13.5 15V16.5H12C11.8011 16.5 11.6103 16.421 11.4697 16.2803C11.329 16.1397 11.25 15.9489 11.25 15.75V8.25C11.25 8.05109 11.329 7.86032 11.4697 7.71967C11.6103 7.57902 11.8011 7.5 12 7.5H13.5V9C13.5 9.39782 13.658 9.77936 13.9393 10.0607C14.2206 10.342 14.6022 10.5 15 10.5ZM5.25 13.5H2.25V10.5H5.25V13.5ZM15 15H19.5V19.5H15V15ZM15 4.5H19.5V9H15V4.5Z'
        />
      </g>
    </svg>
  )
}

export function TableIcon({ className }: { className?: string }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/grid' fill='url(#purpleGradient)'>
        <path
          id='Vector'
          d='M21 4.5H3C2.80109 4.5 2.61032 4.57902 2.46967 4.71967C2.32902 4.86032 2.25 5.05109 2.25 5.25V18C2.25 18.3978 2.40804 18.7794 2.68934 19.0607C2.97064 19.342 3.35218 19.5 3.75 19.5H20.25C20.6478 19.5 21.0294 19.342 21.3107 19.0607C21.592 18.7794 21.75 18.3978 21.75 18V5.25C21.75 5.05109 21.671 4.86032 21.5303 4.71967C21.3897 4.57902 21.1989 4.5 21 4.5ZM3.75 10.5H7.5V13.5H3.75V10.5ZM9 10.5H20.25V13.5H9V10.5ZM20.25 6V9H3.75V6H20.25ZM3.75 15H7.5V18H3.75V15ZM20.25 18H9V15H20.25V18Z'
        />
      </g>
    </svg>
  )
}

export function DocumentIcon({ className }: { className?: string }) {
  return (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/doc' fill='url(#purpleGradient)'>
        <path d='M17.0306 5.71938L11.7806 0.469375C11.7109 0.399749 11.6282 0.344539 11.5371 0.306898C11.4461 0.269257 11.3485 0.249923 11.25 0.25H2.25C1.85218 0.25 1.47064 0.408035 1.18934 0.68934C0.908035 0.970645 0.75 1.35218 0.75 1.75V18.25C0.75 18.6478 0.908035 19.0294 1.18934 19.3107C1.47064 19.592 1.85218 19.75 2.25 19.75H15.75C16.1478 19.75 16.5294 19.592 16.8107 19.3107C17.092 19.0294 17.25 18.6478 17.25 18.25V6.25C17.2501 6.15148 17.2307 6.05391 17.1931 5.96286C17.1555 5.87182 17.1003 5.78908 17.0306 5.71938ZM12 2.81031L14.6897 5.5H12V2.81031ZM15.75 18.25H2.25V1.75H10.5V6.25C10.5 6.44891 10.579 6.63968 10.7197 6.78033C10.8603 6.92098 11.0511 7 11.25 7H15.75V18.25ZM12.75 10.75C12.75 10.9489 12.671 11.1397 12.5303 11.2803C12.3897 11.421 12.1989 11.5 12 11.5H6C5.80109 11.5 5.61032 11.421 5.46967 11.2803C5.32902 11.1397 5.25 10.9489 5.25 10.75C5.25 10.5511 5.32902 10.3603 5.46967 10.2197C5.61032 10.079 5.80109 10 6 10H12C12.1989 10 12.3897 10.079 12.5303 10.2197C12.671 10.3603 12.75 10.5511 12.75 10.75ZM12.75 13.75C12.75 13.9489 12.671 14.1397 12.5303 14.2803C12.3897 14.421 12.1989 14.5 12 14.5H6C5.80109 14.5 5.61032 14.421 5.46967 14.2803C5.32902 14.1397 5.25 13.9489 5.25 13.75C5.25 13.5511 5.32902 13.3603 5.46967 13.2197C5.61032 13.079 5.80109 13 6 13H12C12.1989 13 12.3897 13.079 12.5303 13.2197C12.671 13.3603 12.75 13.5511 12.75 13.75Z' />
      </g>
    </svg>
  )
}

export function RepositoryIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/bookmark' fill='url(#purpleGradient)'>
        <path
          id='Vector'
          d='M19.5 2.25H6.75C5.95435 2.25 5.19129 2.56607 4.62868 3.12868C4.06607 3.69129 3.75 4.45435 3.75 5.25V21C3.75 21.1989 3.82902 21.3897 3.96967 21.5303C4.11032 21.671 4.30109 21.75 4.5 21.75H18C18.1989 21.75 18.3897 21.671 18.5303 21.5303C18.671 21.3897 18.75 21.1989 18.75 21C18.75 20.8011 18.671 20.6103 18.5303 20.4697C18.3897 20.329 18.1989 20.25 18 20.25H5.25C5.25 19.8522 5.40804 19.4706 5.68934 19.1893C5.97064 18.908 6.35218 18.75 6.75 18.75H19.5C19.6989 18.75 19.8897 18.671 20.0303 18.5303C20.171 18.3897 20.25 18.1989 20.25 18V3C20.25 2.80109 20.171 2.61032 20.0303 2.46967C19.8897 2.32902 19.6989 2.25 19.5 2.25ZM11.25 3.75H15.75V10.5L13.9491 9.15C13.8192 9.05263 13.6613 9 13.4991 9C13.3368 9 13.1789 9.05263 13.0491 9.15L11.25 10.5V3.75ZM18.75 17.25H6.75C6.22326 17.2493 5.70572 17.388 5.25 17.6522V5.25C5.25 4.85218 5.40804 4.47064 5.68934 4.18934C5.97064 3.90804 6.35218 3.75 6.75 3.75H9.75V12C9.75 12.1393 9.78879 12.2758 9.86201 12.3943C9.93524 12.5128 10.04 12.6085 10.1646 12.6708C10.2892 12.7331 10.4286 12.7595 10.5674 12.747C10.7061 12.7345 10.8386 12.6836 10.95 12.6L13.5 10.6875L16.0509 12.6C16.1805 12.6972 16.338 12.7498 16.5 12.75C16.6989 12.75 16.8897 12.671 17.0303 12.5303C17.171 12.3897 17.25 12.1989 17.25 12V3.75H18.75V17.25Z'
        />
      </g>
    </svg>
  )
}

export function ChatIcon() {
  return (
    <svg
      stroke='currentColor'
      fill='currentColor'
      strokeWidth='0'
      viewBox='0 0 24 24'
      height='24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/bookmark' fill='url(#purpleGradient)'>
        <path d='M5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455Z'></path>
      </g>
    </svg>
  )
}

export function NodeJsIcon() {
  return (
    <svg
      stroke='currentColor'
      fill='currentColor'
      strokeWidth='0'
      viewBox='0 0 24 24'
      height='24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/nodejs' fill='url(#purpleGradient)'>
        <path d='M11.174 22.5552C11.4297 22.6937 11.7051 22.7729 12.0002 22.7729C12.2952 22.7729 12.5902 22.6937 12.8262 22.5947L20.6745 18.023C21.1854 17.7261 21.5 17.172 21.5 16.5781V7.45437C21.5 6.86056 21.1854 6.30644 20.6745 6.00954L12.8262 1.43778C12.3345 1.16072 11.6657 1.16072 11.174 1.43778L3.32604 6.00954C2.81468 6.30644 2.5 6.86056 2.5 7.45437V16.5781C2.5 17.172 2.81468 17.7261 3.32604 18.023L5.3913 19.2105C6.39448 19.7052 6.74854 19.7052 7.20089 19.7052C8.67604 19.7052 9.52182 18.7948 9.52182 17.2313V8.22623C9.52182 8.08765 9.4038 7.98875 9.28578 7.98875H8.28271C8.14495 7.98875 8.04667 8.10749 8.04667 8.22623V17.2313C8.04667 17.924 7.31891 18.6167 6.15844 18.023L4.01453 16.776C3.93578 16.7365 3.89651 16.6376 3.89651 16.5584V7.43453C3.89651 7.35536 3.93578 7.25647 4.01453 7.21689L11.8625 2.66486C11.9214 2.62528 12.0198 2.62528 12.0984 2.66486L19.9466 7.21689C20.0247 7.25647 20.0648 7.33563 20.0648 7.43453V16.5584C20.0648 16.6573 20.0247 16.7365 19.9466 16.776L12.0984 21.3479C12.0394 21.3875 11.9411 21.3875 11.8625 21.3479L9.85624 20.1407C9.79723 20.1011 9.71849 20.0812 9.65948 20.1208C9.10875 20.4375 9.01047 20.477 8.47937 20.6552C8.36135 20.6948 8.16469 20.774 8.55802 20.9917L11.174 22.5552ZM10.2887 13.5698C10.2887 14.9156 10.9967 16.499 14.4393 16.499C16.9169 16.499 18.3531 15.5093 18.3531 13.7677C18.3531 12.0657 17.212 11.6104 14.7929 11.2938C12.3539 10.9772 12.0982 10.799 12.0982 10.225C12.0982 9.75008 12.3146 9.11679 14.1242 9.11679C15.7367 9.11679 16.3463 9.47302 16.5828 10.5615C16.6023 10.6605 16.701 10.7397 16.7987 10.7397H17.8411C17.9008 10.7397 17.9594 10.7001 17.9994 10.6605C18.0385 10.6011 18.058 10.5418 18.058 10.4824C17.9008 8.58241 16.6619 7.71155 14.1438 7.71155C11.9015 7.71155 10.564 8.66157 10.564 10.2646C10.564 11.9865 11.9015 12.4615 14.0454 12.6792C16.6219 12.9365 16.8192 13.3126 16.8192 13.8271C16.8192 14.7177 16.1109 15.0938 14.4588 15.0938C12.3736 15.0938 11.9212 14.5792 11.7639 13.5302C11.7639 13.4115 11.6655 13.3323 11.5475 13.3323H10.5247C10.387 13.3323 10.2887 13.4511 10.2887 13.5698Z'></path>
      </g>
    </svg>
  )
}

export function MigrationIcon() {
  return (
    <svg
      stroke='currentColor'
      fill='currentColor'
      strokeWidth='0'
      viewBox='0 0 24 24'
      height='24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <g id='icon/migration' fill='url(#purpleGradient)'>
        <path fill='none' d='M0 0h24v24H0z'></path>
        <path d='M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l1.41 1.41.59.59H20v10zm-7.84-6H8v2h4.16l-1.59 1.59L11.99 17 16 13.01 11.99 9l-1.41 1.41L12.16 12z'></path>
      </g>
    </svg>
  )
}

export function CloseIcon() {
  return (
    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='icon/close'>
        <path
          id='Vector'
          d='M19.9904 18.2193C20.0601 18.289 20.1154 18.3717 20.1531 18.4628C20.1908 18.5538 20.2102 18.6514 20.2102 18.7499C20.2102 18.8485 20.1908 18.9461 20.1531 19.0371C20.1154 19.1281 20.0601 19.2109 19.9904 19.2806C19.9207 19.3502 19.838 19.4055 19.7469 19.4432C19.6559 19.4809 19.5583 19.5003 19.4598 19.5003C19.3612 19.5003 19.2636 19.4809 19.1726 19.4432C19.0816 19.4055 18.9988 19.3502 18.9291 19.2806L12.7098 13.0602L6.49039 19.2806C6.34966 19.4213 6.15879 19.5003 5.95977 19.5003C5.76074 19.5003 5.56987 19.4213 5.42914 19.2806C5.28841 19.1398 5.20935 18.949 5.20935 18.7499C5.20935 18.5509 5.28841 18.36 5.42914 18.2193L11.6495 11.9999L5.42914 5.78055C5.28841 5.63982 5.20935 5.44895 5.20935 5.24993C5.20935 5.05091 5.28841 4.86003 5.42914 4.7193C5.56987 4.57857 5.76074 4.49951 5.95977 4.49951C6.15879 4.49951 6.34966 4.57857 6.49039 4.7193L12.7098 10.9396L18.9291 4.7193C19.0699 4.57857 19.2607 4.49951 19.4598 4.49951C19.6588 4.49951 19.8497 4.57857 19.9904 4.7193C20.1311 4.86003 20.2102 5.05091 20.2102 5.24993C20.2102 5.44895 20.1311 5.63982 19.9904 5.78055L13.7701 11.9999L19.9904 18.2193Z'
          fill='#262626'
        />
      </g>
    </svg>
  )
}

export function RemoveIcon({ className }: Props) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon'>
        <path
          id='Vector'
          d='M10 1.25C5.16797 1.25 1.25 5.16797 1.25 10C1.25 14.832 5.16797 18.75 10 18.75C14.832 18.75 18.75 14.832 18.75 10C18.75 5.16797 14.832 1.25 10 1.25ZM13.2305 13.3242L11.9414 13.3184L10 11.0039L8.06055 13.3164L6.76953 13.3223C6.68359 13.3223 6.61328 13.2539 6.61328 13.166C6.61328 13.1289 6.62695 13.0938 6.65039 13.0645L9.19141 10.0371L6.65039 7.01172C6.62679 6.98309 6.61369 6.94725 6.61328 6.91016C6.61328 6.82422 6.68359 6.75391 6.76953 6.75391L8.06055 6.75977L10 9.07422L11.9395 6.76172L13.2285 6.75586C13.3145 6.75586 13.3848 6.82422 13.3848 6.91211C13.3848 6.94922 13.3711 6.98438 13.3477 7.01367L10.8105 10.0391L13.3496 13.0664C13.373 13.0957 13.3867 13.1309 13.3867 13.168C13.3867 13.2539 13.3164 13.3242 13.2305 13.3242Z'
          fill='#D6D6D6'
        />
      </g>
    </svg>
  )
}

export function StopIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon'>
        <path
          id='Vector'
          d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11 8.375C11 8.44375 10.9438 8.5 10.875 8.5H5.125C5.05625 8.5 5 8.44375 5 8.375V7.625C5 7.55625 5.05625 7.5 5.125 7.5H10.875C10.9438 7.5 11 7.55625 11 7.625V8.375Z'
          fill='#EA462D'
        />
      </g>
    </svg>
  )
}

export function PdfIcon({ className }: Props) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon / FilePdfFilled'>
        <path
          id='Vector'
          d='M20.0297 6.76641C20.1703 6.90703 20.25 7.09687 20.25 7.29609V21.75C20.25 22.1648 19.9148 22.5 19.5 22.5H4.5C4.08516 22.5 3.75 22.1648 3.75 21.75V2.25C3.75 1.83516 4.08516 1.5 4.5 1.5H14.4539C14.6531 1.5 14.8453 1.57969 14.9859 1.72031L20.0297 6.76641ZM18.5203 7.64062L14.1094 3.22969V7.64062H18.5203ZM14.8411 14.9358C14.4853 14.9241 14.107 14.9515 13.6774 15.0052C13.1079 14.6538 12.7245 14.1713 12.4521 13.4623L12.4772 13.3596L12.5062 13.2382C12.607 12.8133 12.6612 12.5032 12.6773 12.1905C12.6895 11.9545 12.6764 11.7368 12.6345 11.535C12.5571 11.0993 12.2489 10.8445 11.8605 10.8288C11.4984 10.8141 11.1656 11.0163 11.0805 11.3297C10.942 11.8364 11.0231 12.5032 11.3168 13.6404C10.9427 14.5322 10.4484 15.5777 10.1168 16.1609C9.67406 16.3891 9.3293 16.5968 9.03961 16.827C8.65758 17.1309 8.41898 17.4434 8.35336 17.7715C8.32148 17.9236 8.36953 18.1223 8.47898 18.2852C8.6032 18.4699 8.79023 18.5899 9.01453 18.6073C9.58055 18.6511 10.2762 18.0675 11.0442 16.7496C11.1213 16.7238 11.2029 16.6966 11.3025 16.6629L11.5814 16.5687C11.7579 16.5091 11.8859 16.4665 12.0124 16.4255C12.5609 16.2469 12.9757 16.1341 13.353 16.0699C14.0088 16.421 14.7668 16.6512 15.2773 16.6512C15.6987 16.6512 15.9834 16.4327 16.0863 16.0889C16.1766 15.787 16.1051 15.4369 15.911 15.2433C15.7104 15.0462 15.3415 14.952 14.8411 14.9358ZM9.02883 17.9456V17.9372L9.03187 17.9292C9.06617 17.8406 9.11019 17.756 9.16313 17.677C9.26344 17.5228 9.40148 17.3606 9.57258 17.1879C9.66445 17.0953 9.76008 17.0051 9.87234 16.9038C9.89742 16.8813 10.0577 16.7386 10.0877 16.7105L10.3495 16.4667L10.1592 16.7698C9.87047 17.2301 9.60938 17.5615 9.38578 17.7776C9.30352 17.8573 9.23109 17.9159 9.1725 17.9536C9.15316 17.9665 9.13268 17.9777 9.11133 17.9869C9.10172 17.9909 9.09328 17.9932 9.08484 17.9939C9.07594 17.995 9.06689 17.9938 9.05859 17.9904C9.04977 17.9867 9.04224 17.9805 9.03694 17.9725C9.03165 17.9645 9.02882 17.9552 9.02883 17.9456ZM11.9805 12.8297L11.9276 12.9234L11.8948 12.8208C11.8221 12.5904 11.7687 12.2433 11.7539 11.9302C11.737 11.5739 11.7654 11.3602 11.8779 11.3602C12.0359 11.3602 12.1083 11.6133 12.1139 11.9941C12.1191 12.3288 12.0663 12.6771 11.9803 12.8297H11.9805ZM11.8444 14.1998L11.8802 14.1049L11.9292 14.194C12.2032 14.6918 12.5588 15.1071 12.9497 15.3966L13.0341 15.4589L12.9312 15.48C12.5484 15.5592 12.192 15.6783 11.7045 15.8749C11.7553 15.8543 11.1977 16.0826 11.0566 16.1367L10.9336 16.1838L10.9992 16.0695C11.2887 15.5655 11.5561 14.9604 11.8441 14.1998H11.8444ZM15.5386 15.9872C15.3544 16.0598 14.9578 15.9949 14.2596 15.6968L14.0824 15.6213L14.2746 15.6073C14.8207 15.5667 15.2074 15.5967 15.4329 15.6792C15.529 15.7144 15.593 15.7587 15.6213 15.8093C15.6363 15.8333 15.6413 15.8621 15.6353 15.8897C15.6294 15.9173 15.6129 15.9415 15.5895 15.9572C15.5746 15.9703 15.5573 15.9805 15.5386 15.9872Z'
          fill='black'
          fillOpacity='0.45'
        />
      </g>
    </svg>
  )
}

export function HelpHubIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='icon'>
        <path
          id='Vector'
          d='M19.5 2.25H6.75C5.95435 2.25 5.19129 2.56607 4.62868 3.12868C4.06607 3.69129 3.75 4.45435 3.75 5.25V21C3.75 21.1989 3.82902 21.3897 3.96967 21.5303C4.11032 21.671 4.30109 21.75 4.5 21.75H18C18.1989 21.75 18.3897 21.671 18.5303 21.5303C18.671 21.3897 18.75 21.1989 18.75 21C18.75 20.8011 18.671 20.6103 18.5303 20.4697C18.3897 20.329 18.1989 20.25 18 20.25H5.25C5.25 19.8522 5.40804 19.4706 5.68934 19.1893C5.97064 18.908 6.35218 18.75 6.75 18.75H19.5C19.6989 18.75 19.8897 18.671 20.0303 18.5303C20.171 18.3897 20.25 18.1989 20.25 18V3C20.25 2.80109 20.171 2.61032 20.0303 2.46967C19.8897 2.32902 19.6989 2.25 19.5 2.25ZM11.25 3.75H15.75V10.5L13.9491 9.15C13.8192 9.05263 13.6613 9 13.4991 9C13.3368 9 13.1789 9.05263 13.0491 9.15L11.25 10.5V3.75ZM18.75 17.25H6.75C6.22326 17.2493 5.70572 17.388 5.25 17.6522V5.25C5.25 4.85218 5.40804 4.47064 5.68934 4.18934C5.97064 3.90804 6.35218 3.75 6.75 3.75H9.75V12C9.75 12.1393 9.78879 12.2758 9.86201 12.3943C9.93524 12.5128 10.04 12.6085 10.1646 12.6708C10.2892 12.7331 10.4286 12.7595 10.5674 12.747C10.7061 12.7345 10.8386 12.6836 10.95 12.6L13.5 10.6875L16.0509 12.6C16.1805 12.6972 16.338 12.7498 16.5 12.75C16.6989 12.75 16.8897 12.671 17.0303 12.5303C17.171 12.3897 17.25 12.1989 17.25 12V3.75H18.75V17.25Z'
          fill='#262626'
        />
      </g>
    </svg>
  )
}

export function CheckIcon({ className }: Props) {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Check'>
        <path
          id='icon'
          d='M9.07801 16.3105L4.87179 12.1042L3.43945 13.5265L9.07801 19.165L21.1823 7.0608L19.76 5.63855L9.07801 16.3105Z'
          fill='#4F378A'
        />
      </g>
    </svg>
  )
}

export function ChevronDownIcon({ className }: Props) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Chevron down'>
        <path
          id='Icon'
          d='M5 7.5L10 12.5L15 7.5'
          stroke='#1E1E1E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export function ChevronLeftIcon({ className }: Props) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon'>
        <path
          id='icon'
          d='M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z'
          fill='#1D1B20'
        />
      </g>
    </svg>
  )
}

interface Props {
  className?: string
  style?: React.CSSProperties
}

export function CheckIcon2({ className }: Props) {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M10.25 16.4L6.25 12.4L7.65 11L10.25 13.6L16.85 7L18.25 8.4L10.25 16.4Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function HelpIcon({ className }: Props) {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon' clipPath='url(#clip0_162_1072)'>
        <path
          id='Vector'
          d='M13.875 16.875C13.875 17.0975 13.809 17.315 13.6854 17.5C13.5618 17.685 13.3861 17.8292 13.1805 17.9144C12.975 17.9995 12.7488 18.0218 12.5305 17.9784C12.3123 17.935 12.1118 17.8278 11.9545 17.6705C11.7972 17.5132 11.69 17.3127 11.6466 17.0945C11.6032 16.8762 11.6255 16.65 11.7106 16.4445C11.7958 16.2389 11.94 16.0632 12.125 15.9396C12.31 15.816 12.5275 15.75 12.75 15.75C13.0484 15.75 13.3345 15.8685 13.5455 16.0795C13.7565 16.2905 13.875 16.5766 13.875 16.875ZM12.75 6.75C10.6819 6.75 9 8.26406 9 10.125V10.5C9 10.6989 9.07902 10.8897 9.21967 11.0303C9.36033 11.171 9.55109 11.25 9.75 11.25C9.94892 11.25 10.1397 11.171 10.2803 11.0303C10.421 10.8897 10.5 10.6989 10.5 10.5V10.125C10.5 9.09375 11.5097 8.25 12.75 8.25C13.9903 8.25 15 9.09375 15 10.125C15 11.1562 13.9903 12 12.75 12C12.5511 12 12.3603 12.079 12.2197 12.2197C12.079 12.3603 12 12.5511 12 12.75V13.5C12 13.6989 12.079 13.8897 12.2197 14.0303C12.3603 14.171 12.5511 14.25 12.75 14.25C12.9489 14.25 13.1397 14.171 13.2803 14.0303C13.421 13.8897 13.5 13.6989 13.5 13.5V13.4325C15.21 13.1184 16.5 11.7544 16.5 10.125C16.5 8.26406 14.8181 6.75 12.75 6.75ZM22.5 12C22.5 13.9284 21.9282 15.8134 20.8568 17.4168C19.7855 19.0202 18.2627 20.2699 16.4812 21.0078C14.6996 21.7458 12.7392 21.9389 10.8479 21.5627C8.95656 21.1865 7.21928 20.2579 5.85571 18.8943C4.49215 17.5307 3.56355 15.7934 3.18735 13.9021C2.81114 12.0108 3.00422 10.0504 3.74218 8.26884C4.48013 6.48726 5.72982 4.96451 7.33319 3.89317C8.93657 2.82183 10.8216 2.25 12.75 2.25C15.335 2.25273 17.8134 3.28084 19.6413 5.10872C21.4692 6.93661 22.4973 9.41498 22.5 12ZM21 12C21 10.3683 20.5161 8.77325 19.6096 7.41655C18.7031 6.05984 17.4146 5.00242 15.9071 4.37799C14.3997 3.75357 12.7409 3.59019 11.1405 3.90852C9.54017 4.22685 8.07016 5.01259 6.91637 6.16637C5.76259 7.32015 4.97685 8.79016 4.65853 10.3905C4.3402 11.9908 4.50358 13.6496 5.128 15.1571C5.75242 16.6646 6.80984 17.9531 8.16655 18.8596C9.52326 19.7661 11.1183 20.25 12.75 20.25C14.9373 20.2475 17.0343 19.3775 18.5809 17.8309C20.1275 16.2843 20.9975 14.1873 21 12Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_162_1072'>
          <rect width='24' height='24' fill='white' transform='translate(0.75)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SupportIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M2.66536 8C2.66536 5.05448 5.05318 2.66667 7.9987 2.66667C10.9442 2.66667 13.332 5.05448 13.332 8C13.332 10.9455 10.9442 13.3333 7.9987 13.3333C5.05318 13.3333 2.66536 10.9455 2.66536 8ZM7.9987 1.33333C4.3168 1.33333 1.33203 4.3181 1.33203 8C1.33203 11.6819 4.3168 14.6667 7.9987 14.6667C11.6806 14.6667 14.6654 11.6819 14.6654 8C14.6654 4.3181 11.6806 1.33333 7.9987 1.33333ZM5.33203 6.52632H6.66536C6.67736 5.80884 7.1347 5.12281 7.9987 5.12281C8.6347 5.12281 9.33203 5.47537 9.33203 6.09179C9.33203 6.60575 8.80045 6.95752 8.34688 7.25766L8.26536 7.31172C7.78603 7.62554 7.40403 7.88997 7.33203 8.76912V9.33333H8.61736L8.66536 8.8393C8.77336 8.24421 9.21603 7.86021 9.73203 7.53684C10.2474 7.20337 10.6654 6.93053 10.6654 5.95032C10.6654 5.17165 10.266 4 7.9987 4C6.2467 4 5.36803 5.08183 5.33203 6.52632ZM8.66536 12V10.6667H7.33203V12H8.66536Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function MailIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon / Mail'>
        <path
          id='Vector'
          d='M14 3.5H2C1.73478 3.5 1.48043 3.60536 1.29289 3.79289C1.10536 3.98043 1 4.23478 1 4.5V11.5C1 11.7652 1.10536 12.0196 1.29289 12.2071C1.48043 12.3946 1.73478 12.5 2 12.5H14C14.2652 12.5 14.5196 12.3946 14.7071 12.2071C14.8946 12.0196 15 11.7652 15 11.5V4.5C15 4.23478 14.8946 3.98043 14.7071 3.79289C14.5196 3.60536 14.2652 3.5 14 3.5ZM13.5 4.5V5.2075L8 8.6925L2.5 5.2075V4.5H13.5ZM2 12H14V6.2925L8 9.7775L2 6.2925V12Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export function SupportContactIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M1.33203 2H14.6654V14H1.33203V2ZM2.66536 4.15123V12.6667H13.332V4.15123L7.9987 8.89197L2.66536 4.15123ZM12.2452 3.33333H3.75216L7.9987 7.10803L12.2452 3.33333Z'
        fill='#161513'
      />
    </svg>
  )
}

export function CommunityIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_2837_1385)'>
        <path
          d='M10.6667 6.66667C10.6667 6.40296 10.7449 6.14518 10.8914 5.92591C11.0379 5.70665 11.2461 5.53575 11.4898 5.43483C11.7334 5.33392 12.0015 5.30751 12.2601 5.35896C12.5188 5.4104 12.7563 5.53739 12.9428 5.72386C13.1293 5.91033 13.2563 6.14791 13.3077 6.40655C13.3592 6.66519 13.3328 6.93328 13.2318 7.17692C13.1309 7.42055 12.96 7.62879 12.7408 7.7753C12.5215 7.92181 12.2637 8 12 8H8M8 8V4.00001C8 3.64638 8.14048 3.30724 8.39052 3.0572C8.64057 2.80715 8.97971 2.66667 9.33333 2.66667C9.68696 2.66667 10.0261 2.80715 10.2761 3.0572C10.5262 3.30724 10.6667 3.64638 10.6667 4.00001V8H8Z'
          stroke='black'
          strokeOpacity='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.33333 10.6667C9.59704 10.6667 9.85483 10.7449 10.0741 10.8914C10.2934 11.0379 10.4643 11.2461 10.5652 11.4898C10.6661 11.7334 10.6925 12.0015 10.641 12.2601C10.5896 12.5188 10.4626 12.7563 10.2761 12.9428C10.0897 13.1293 9.85209 13.2563 9.59345 13.3077C9.33481 13.3592 9.06672 13.3328 8.82309 13.2318C8.57945 13.1309 8.37122 12.96 8.22471 12.7408C8.0782 12.5215 8 12.2637 8 12V8M8 8H12C12.3536 8 12.6928 8.14048 12.9428 8.39052C13.1929 8.64057 13.3333 8.97971 13.3333 9.33333C13.3333 9.68696 13.1929 10.0261 12.9428 10.2761C12.6928 10.5262 12.3536 10.6667 12 10.6667H8V8Z'
          stroke='black'
          strokeOpacity='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.33317 9.33333C5.33317 9.59704 5.25497 9.85483 5.10846 10.0741C4.96196 10.2934 4.75372 10.4643 4.51008 10.5652C4.26645 10.6661 3.99836 10.6925 3.73972 10.641C3.48108 10.5896 3.2435 10.4626 3.05703 10.2761C2.87056 10.0897 2.74357 9.85209 2.69212 9.59345C2.64068 9.33481 2.66708 9.06672 2.768 8.82309C2.86892 8.57945 3.03981 8.37122 3.25908 8.22471C3.47834 8.0782 3.73613 8 3.99984 8H7.99984M7.99984 8V12C7.99984 12.3536 7.85936 12.6928 7.60931 12.9428C7.35926 13.1929 7.02013 13.3333 6.6665 13.3333C6.31288 13.3333 5.97374 13.1929 5.7237 12.9428C5.47365 12.6928 5.33317 12.3536 5.33317 12V8H7.99984Z'
          stroke='black'
          strokeOpacity='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.6665 5.33334C6.4028 5.33334 6.14501 5.25514 5.92574 5.10863C5.70648 4.96212 5.53558 4.75389 5.43466 4.51025C5.33375 4.26662 5.30734 3.99853 5.35879 3.73989C5.41024 3.48124 5.53722 3.24367 5.72369 3.0572C5.91016 2.87073 6.14774 2.74374 6.40638 2.69229C6.66502 2.64085 6.93311 2.66725 7.17675 2.76817C7.42038 2.86908 7.62862 3.03998 7.77513 3.25925C7.92164 3.47851 7.99984 3.7363 7.99984 4.00001V8.00001M7.99984 8.00001H3.99984C3.64622 8.00001 3.30708 7.85953 3.05703 7.60948C2.80698 7.35943 2.6665 7.02029 2.6665 6.66667C2.6665 6.31305 2.80698 5.97391 3.05703 5.72386C3.30708 5.47382 3.64622 5.33334 3.99984 5.33334H7.99984V8.00001Z'
          stroke='black'
          strokeOpacity='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2837_1385'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function BookIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M2.6665 12.6667V3.33333C2.6665 2.59695 3.26346 2 3.99984 2H12.9332C13.1541 2 13.3332 2.17909 13.3332 2.4V11.1429'
        stroke='#21272A'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M5.3335 2V7.33333L7.00016 6.26667L8.66683 7.33333V2'
        stroke='#21272A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M4 11.3333H13.3333' stroke='#21272A' strokeWidth='1.5' strokeLinecap='round' />
      <path d='M4 14H13.3333' stroke='#21272A' strokeWidth='1.5' strokeLinecap='round' />
      <path
        d='M3.99984 14C3.26346 14 2.6665 13.4031 2.6665 12.6667C2.6665 11.9303 3.26346 11.3333 3.99984 11.3333'
        stroke='#21272A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function QuestionMarkIcon({ className }: Props) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_530_1346)'>
        <path
          d='M13.125 16.875C13.125 17.0975 13.059 17.315 12.9354 17.5C12.8118 17.685 12.6361 17.8292 12.4305 17.9144C12.225 17.9995 11.9988 18.0218 11.7805 17.9784C11.5623 17.935 11.3618 17.8278 11.2045 17.6705C11.0472 17.5132 10.94 17.3127 10.8966 17.0945C10.8532 16.8762 10.8755 16.65 10.9606 16.4445C11.0458 16.2389 11.19 16.0632 11.375 15.9396C11.56 15.816 11.7775 15.75 12 15.75C12.2984 15.75 12.5845 15.8685 12.7955 16.0795C13.0065 16.2905 13.125 16.5766 13.125 16.875ZM12 6.75C9.93188 6.75 8.25 8.26406 8.25 10.125V10.5C8.25 10.6989 8.32902 10.8897 8.46967 11.0303C8.61032 11.171 8.80109 11.25 9 11.25C9.19891 11.25 9.38968 11.171 9.53033 11.0303C9.67098 10.8897 9.75 10.6989 9.75 10.5V10.125C9.75 9.09375 10.7597 8.25 12 8.25C13.2403 8.25 14.25 9.09375 14.25 10.125C14.25 11.1562 13.2403 12 12 12C11.8011 12 11.6103 12.079 11.4697 12.2197C11.329 12.3603 11.25 12.5511 11.25 12.75V13.5C11.25 13.6989 11.329 13.8897 11.4697 14.0303C11.6103 14.171 11.8011 14.25 12 14.25C12.1989 14.25 12.3897 14.171 12.5303 14.0303C12.671 13.8897 12.75 13.6989 12.75 13.5V13.4325C14.46 13.1184 15.75 11.7544 15.75 10.125C15.75 8.26406 14.0681 6.75 12 6.75ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46927 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43734 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97981 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7661 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6496 3.75357 11.9908 3.59019 10.3905 3.90852C8.79016 4.22685 7.32015 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90852 10.3905C3.59019 11.9908 3.75357 13.6496 4.37799 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77325 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_530_1346'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export function CopyLinkIcon({ className }: Props) {
  return (
    <svg
      width='768'
      height='24'
      viewBox='0 0 768 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_837_325)'>
        <path
          d='M392.25 3H380.25C380.051 3 379.86 3.07902 379.72 3.21967C379.579 3.36032 379.5 3.55109 379.5 3.75V7.5H375.75C375.551 7.5 375.36 7.57902 375.22 7.71967C375.079 7.86032 375 8.05109 375 8.25V20.25C375 20.4489 375.079 20.6397 375.22 20.7803C375.36 20.921 375.551 21 375.75 21H387.75C387.949 21 388.14 20.921 388.28 20.7803C388.421 20.6397 388.5 20.4489 388.5 20.25V16.5H392.25C392.449 16.5 392.64 16.421 392.78 16.2803C392.921 16.1397 393 15.9489 393 15.75V3.75C393 3.55109 392.921 3.36032 392.78 3.21967C392.64 3.07902 392.449 3 392.25 3ZM387 19.5H376.5V9H387V19.5ZM391.5 15H388.5V8.25C388.5 8.05109 388.421 7.86032 388.28 7.71967C388.14 7.57902 387.949 7.5 387.75 7.5H381V4.5H391.5V15Z'
          fill='url(#paint0_linear_837_325)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_837_325'
          x1='375'
          y1='12'
          x2='393'
          y2='12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <clipPath id='clip0_837_325'>
          <rect width='24' height='24' fill='white' transform='translate(372)' />
        </clipPath>
      </defs>
    </svg>
  )
}
export function CloseIcon2({ className }: Props) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M19.2806 18.2193C19.3503 18.289 19.4056 18.3717 19.4433 18.4628C19.481 18.5538 19.5004 18.6514 19.5004 18.7499C19.5004 18.8485 19.481 18.9461 19.4433 19.0371C19.4056 19.1281 19.3503 19.2109 19.2806 19.2806C19.2109 19.3502 19.1282 19.4055 19.0372 19.4432C18.9461 19.4809 18.8485 19.5003 18.75 19.5003C18.6514 19.5003 18.5539 19.4809 18.4628 19.4432C18.3718 19.4055 18.289 19.3502 18.2194 19.2806L12 13.0602L5.78061 19.2806C5.63988 19.4213 5.44901 19.5003 5.24999 19.5003C5.05097 19.5003 4.8601 19.4213 4.71936 19.2806C4.57863 19.1398 4.49957 18.949 4.49957 18.7499C4.49957 18.5509 4.57863 18.36 4.71936 18.2193L10.9397 11.9999L4.71936 5.78055C4.57863 5.63982 4.49957 5.44895 4.49957 5.24993C4.49957 5.05091 4.57863 4.86003 4.71936 4.7193C4.8601 4.57857 5.05097 4.49951 5.24999 4.49951C5.44901 4.49951 5.63988 4.57857 5.78061 4.7193L12 10.9396L18.2194 4.7193C18.3601 4.57857 18.551 4.49951 18.75 4.49951C18.949 4.49951 19.1399 4.57857 19.2806 4.7193C19.4213 4.86003 19.5004 5.05091 19.5004 5.24993C19.5004 5.44895 19.4213 5.63982 19.2806 5.78055L13.0603 11.9999L19.2806 18.2193Z'
        fill='white'
      />
    </svg>
  )
}

export function LibraryIcon({ className }: Props) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 25 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M19.75 2.25H7C6.20435 2.25 5.44129 2.56607 4.87868 3.12868C4.31607 3.69129 4 4.45435 4 5.25V21C4 21.1989 4.07902 21.3897 4.21967 21.5303C4.36032 21.671 4.55109 21.75 4.75 21.75H18.25C18.4489 21.75 18.6397 21.671 18.7803 21.5303C18.921 21.3897 19 21.1989 19 21C19 20.8011 18.921 20.6103 18.7803 20.4697C18.6397 20.329 18.4489 20.25 18.25 20.25H5.5C5.5 19.8522 5.65804 19.4706 5.93934 19.1893C6.22064 18.908 6.60218 18.75 7 18.75H19.75C19.9489 18.75 20.1397 18.671 20.2803 18.5303C20.421 18.3897 20.5 18.1989 20.5 18V3C20.5 2.80109 20.421 2.61032 20.2803 2.46967C20.1397 2.32902 19.9489 2.25 19.75 2.25ZM11.5 3.75H16V10.5L14.1991 9.15C14.0692 9.05263 13.9113 9 13.7491 9C13.5868 9 13.4289 9.05263 13.2991 9.15L11.5 10.5V3.75ZM19 17.25H7C6.47326 17.2493 5.95572 17.388 5.5 17.6522V5.25C5.5 4.85218 5.65804 4.47064 5.93934 4.18934C6.22064 3.90804 6.60218 3.75 7 3.75H10V12C10 12.1393 10.0388 12.2758 10.112 12.3943C10.1852 12.5128 10.29 12.6085 10.4146 12.6708C10.5392 12.7331 10.6786 12.7595 10.8174 12.747C10.9561 12.7345 11.0886 12.6836 11.2 12.6L13.75 10.6875L16.3009 12.6C16.4305 12.6972 16.588 12.7498 16.75 12.75C16.9489 12.75 17.1397 12.671 17.2803 12.5303C17.421 12.3897 17.5 12.1989 17.5 12V3.75H19V17.25Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function IndicatorIcon({ className }: Props) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M9.84812 3.51562H2.15124C1.92038 3.51562 1.79148 3.75937 1.93445 3.92578L5.78288 8.38828C5.89304 8.51602 6.10515 8.51602 6.21648 8.38828L10.0649 3.92578C10.2079 3.75937 10.079 3.51562 9.84812 3.51562Z'
        fill='black'
        fillOpacity='0.88'
      />
    </svg>
  )
}

export function CloseIndicatorIcon({ className }: Props) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M8.38828 5.78313L3.92578 1.93469C3.75937 1.79172 3.51562 1.92063 3.51562 2.15149V9.84836C3.51562 10.0792 3.75937 10.2081 3.92578 10.0652L8.38828 6.21672C8.51602 6.10656 8.51602 5.89328 8.38828 5.78313Z'
        fill='black'
        fillOpacity='0.88'
      />
    </svg>
  )
}
export function FileUploadIcon({ className }: Props) {
  return (
    <svg
      width='720'
      height='32'
      viewBox='0 0 720 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_21_33238)'>
        <path
          d='M374 17.0001V25.0001C374 25.5305 373.789 26.0392 373.414 26.4143C373.039 26.7893 372.53 27.0001 372 27.0001H348C347.47 27.0001 346.961 26.7893 346.586 26.4143C346.211 26.0392 346 25.5305 346 25.0001V17.0001C346 16.4696 346.211 15.9609 346.586 15.5858C346.961 15.2108 347.47 15.0001 348 15.0001H354C354.265 15.0001 354.52 15.1054 354.707 15.2929C354.895 15.4805 355 15.7348 355 16.0001C355 16.2653 354.895 16.5196 354.707 16.7072C354.52 16.8947 354.265 17.0001 354 17.0001H348V25.0001H372V17.0001H366C365.735 17.0001 365.48 16.8947 365.293 16.7072C365.105 16.5196 365 16.2653 365 16.0001C365 15.7348 365.105 15.4805 365.293 15.2929C365.48 15.1054 365.735 15.0001 366 15.0001H372C372.53 15.0001 373.039 15.2108 373.414 15.5858C373.789 15.9609 374 16.4696 374 17.0001ZM354.708 9.70755L359 5.4138V16.0001C359 16.2653 359.105 16.5196 359.293 16.7072C359.48 16.8947 359.735 17.0001 360 17.0001C360.265 17.0001 360.52 16.8947 360.707 16.7072C360.895 16.5196 361 16.2653 361 16.0001V5.4138L365.292 9.70755C365.48 9.8952 365.735 10.0006 366 10.0006C366.265 10.0006 366.52 9.8952 366.708 9.70755C366.895 9.51991 367.001 9.26542 367.001 9.00005C367.001 8.73469 366.895 8.48019 366.708 8.29255L360.708 2.29255C360.615 2.19958 360.504 2.12582 360.383 2.07549C360.262 2.02517 360.131 1.99927 360 1.99927C359.869 1.99927 359.738 2.02517 359.617 2.07549C359.496 2.12582 359.385 2.19958 359.292 2.29255L353.292 8.29255C353.105 8.48019 352.999 8.73469 352.999 9.00005C352.999 9.26542 353.105 9.51991 353.293 9.70755C353.48 9.89519 353.735 10.0006 354 10.0006C354.265 10.0006 354.52 9.8952 354.708 9.70755ZM369 21.0001C369 20.7034 368.912 20.4134 368.747 20.1667C368.582 19.92 368.348 19.7278 368.074 19.6142C367.8 19.5007 367.498 19.471 367.207 19.5289C366.916 19.5868 366.649 19.7296 366.439 19.9394C366.23 20.1492 366.087 20.4164 366.029 20.7074C365.971 20.9984 366.001 21.3 366.114 21.5741C366.228 21.8482 366.42 22.0824 366.667 22.2473C366.913 22.4121 367.203 22.5001 367.5 22.5001C367.898 22.5001 368.279 22.342 368.561 22.0607C368.842 21.7794 369 21.3979 369 21.0001Z'
          fill='url(#paint0_linear_21_33238)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_21_33238'
          x1='346'
          y1='14.4997'
          x2='374'
          y2='14.4997'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <clipPath id='clip0_21_33238'>
          <rect width='32' height='32' fill='white' transform='translate(344)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CopyIcon({ className }: Props) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='copy-03' clipPath='url(#clip0_641_4924)'>
        <path
          id='Icon'
          d='M6.6665 6.66675V4.33341C6.6665 3.39999 6.6665 2.93328 6.84816 2.57676C7.00795 2.26316 7.26292 2.00819 7.57652 1.8484C7.93304 1.66675 8.39975 1.66675 9.33317 1.66675H15.6665C16.5999 1.66675 17.0666 1.66675 17.4232 1.8484C17.7368 2.00819 17.9917 2.26316 18.1515 2.57676C18.3332 2.93328 18.3332 3.39999 18.3332 4.33341V10.6667C18.3332 11.6002 18.3332 12.0669 18.1515 12.4234C17.9917 12.737 17.7368 12.992 17.4232 13.1518C17.0666 13.3334 16.5999 13.3334 15.6665 13.3334H13.3332M4.33317 18.3334H10.6665C11.5999 18.3334 12.0666 18.3334 12.4232 18.1518C12.7368 17.992 12.9917 17.737 13.1515 17.4234C13.3332 17.0669 13.3332 16.6002 13.3332 15.6667V9.33341C13.3332 8.39999 13.3332 7.93328 13.1515 7.57676C12.9917 7.26316 12.7368 7.00819 12.4232 6.8484C12.0666 6.66675 11.5999 6.66675 10.6665 6.66675H4.33317C3.39975 6.66675 2.93304 6.66675 2.57652 6.8484C2.26292 7.00819 2.00795 7.26316 1.84816 7.57676C1.6665 7.93328 1.6665 8.39999 1.6665 9.33341V15.6667C1.6665 16.6002 1.6665 17.0669 1.84816 17.4234C2.00795 17.737 2.26292 17.992 2.57652 18.1518C2.93304 18.3334 3.39975 18.3334 4.33317 18.3334Z'
          stroke='black'
          strokeWidth='1.66667'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_641_4924'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ListItemIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon'>
        <path
          id='vector'
          d='M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z'
          fill='#262626'
        />
      </g>
    </svg>
  )
}

export function StatusSuccessIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992ZM11.4713 6.13799L10.5285 5.19518L6.66659 9.05711L5.13799 7.52851L4.19518 8.47132L6.66659 10.9427L11.4713 6.13799Z'
        fill='#2C8450'
      />
    </svg>
  )
}

export function StatusFailedIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11 8.375C11 8.44375 10.9438 8.5 10.875 8.5H5.125C5.05625 8.5 5 8.44375 5 8.375V7.625C5 7.55625 5.05625 7.5 5.125 7.5H10.875C10.9438 7.5 11 7.55625 11 7.625V8.375Z'
        fill='#EA462D'
      />
    </svg>
  )
}

export function StatusInprogressIcon({ className }: Props) {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_894_2668)'>
        <path
          d='M7 14C6.05527 14 5.13789 13.8154 4.2752 13.4504C3.44121 13.0977 2.69336 12.5918 2.05078 11.9492C1.4082 11.3066 0.902344 10.5588 0.549609 9.7248C0.18457 8.86211 0 7.94473 0 7C0 6.72793 0.220117 6.50781 0.492188 6.50781C0.764258 6.50781 0.984375 6.72793 0.984375 7C0.984375 7.81211 1.14297 8.59961 1.45742 9.34199C1.76094 10.0584 2.19434 10.7023 2.74668 11.2547C3.29902 11.807 3.94297 12.2418 4.65937 12.5439C5.40039 12.857 6.18789 13.0156 7 13.0156C7.81211 13.0156 8.59961 12.857 9.34199 12.5426C10.0584 12.2391 10.7023 11.8057 11.2547 11.2533C11.807 10.701 12.2418 10.057 12.5439 9.34062C12.857 8.59961 13.0156 7.81211 13.0156 7C13.0156 6.18789 12.857 5.40039 12.5426 4.65801C12.2401 3.94332 11.8023 3.29384 11.2533 2.74531C10.7054 2.19559 10.0558 1.7577 9.34062 1.45605C8.59961 1.14297 7.81211 0.984375 7 0.984375C6.72793 0.984375 6.50781 0.764258 6.50781 0.492188C6.50781 0.220117 6.72793 0 7 0C7.94473 0 8.86211 0.18457 9.7248 0.549609C10.5588 0.902344 11.3066 1.4082 11.9492 2.05078C12.5918 2.69336 13.0963 3.44258 13.449 4.2752C13.8141 5.13789 13.9986 6.05527 13.9986 7C13.9986 7.94473 13.8141 8.86211 13.449 9.7248C13.0977 10.5588 12.5918 11.3066 11.9492 11.9492C11.3066 12.5918 10.5574 13.0963 9.7248 13.449C8.86211 13.8154 7.94473 14 7 14Z'
          fill='#262626'
        />
      </g>
      <defs>
        <clipPath id='clip0_894_2668'>
          <rect width='14' height='14' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function StatusSuspendedIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon'>
        <path
          id='vector'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.99967 2.33337L14.6663 14.3334H1.33301L7.99967 2.33337ZM7.33301 10.3334H8.66634V7.66671H7.33301V10.3334ZM7.33301 11V12.3334H8.66634V11H7.33301Z'
          fill='#AD6800'
        />
      </g>
    </svg>
  )
}

export function StatusUnknownIcon({ className }: Props) {
  return (
    <svg
      width='96'
      height='16'
      viewBox='0 0 96 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8 12.0625C7.65469 12.0625 7.375 11.7828 7.375 11.4375C7.375 11.0922 7.65469 10.8125 8 10.8125C8.34531 10.8125 8.625 11.0922 8.625 11.4375C8.625 11.7828 8.34531 12.0625 8 12.0625ZM8.98281 8.63281C8.84131 8.68746 8.71956 8.78347 8.63343 8.90834C8.54731 9.03321 8.50081 9.18113 8.5 9.33281V9.6875C8.5 9.75625 8.44375 9.8125 8.375 9.8125H7.625C7.55625 9.8125 7.5 9.75625 7.5 9.6875V9.35156C7.5 8.99062 7.60469 8.63437 7.81094 8.3375C8.0125 8.04687 8.29375 7.825 8.625 7.69844C9.15625 7.49375 9.5 7.04844 9.5 6.5625C9.5 5.87344 8.82656 5.3125 8 5.3125C7.17344 5.3125 6.5 5.87344 6.5 6.5625V6.68125C6.5 6.75 6.44375 6.80625 6.375 6.80625H5.625C5.55625 6.80625 5.5 6.75 5.5 6.68125V6.5625C5.5 5.94844 5.76875 5.375 6.25625 4.94844C6.725 4.5375 7.34375 4.3125 8 4.3125C8.65625 4.3125 9.275 4.53906 9.74375 4.94844C10.2312 5.375 10.5 5.94844 10.5 6.5625C10.5 7.46562 9.90469 8.27812 8.98281 8.63281Z'
        fill='#AD6800'
      />
      <path
        d='M23 12.16C22.2533 12.16 21.6667 11.9233 21.24 11.45C20.8133 10.9767 20.6 10.3333 20.6 9.52V4.9H21.46V9.52C21.46 10.1067 21.59 10.5533 21.85 10.86C22.1167 11.1667 22.5 11.32 23 11.32C23.5 11.32 23.88 11.1667 24.14 10.86C24.4067 10.5533 24.54 10.1067 24.54 9.52V4.9H25.4V9.52C25.4 10.3333 25.1867 10.9767 24.76 11.45C24.3333 11.9233 23.7467 12.16 23 12.16ZM26.8361 12V6.7H27.6061L27.6361 8.05L27.5361 7.96C27.6028 7.64667 27.7228 7.39 27.8961 7.19C28.0761 6.98333 28.2894 6.83 28.5361 6.73C28.7828 6.63 29.0428 6.58 29.3161 6.58C29.7228 6.58 30.0594 6.67 30.3261 6.85C30.5994 7.03 30.8061 7.27333 30.9461 7.58C31.0861 7.88 31.1561 8.21667 31.1561 8.59V12H30.3161V8.83C30.3161 8.33667 30.2194 7.96333 30.0261 7.71C29.8328 7.45 29.5361 7.32 29.1361 7.32C28.8628 7.32 28.6161 7.38 28.3961 7.5C28.1761 7.61333 27.9994 7.78333 27.8661 8.01C27.7394 8.23 27.6761 8.50333 27.6761 8.83V12H26.8361ZM32.8922 12V4.9H33.7322V9.55L36.3122 6.7H37.4322L35.3422 8.95L37.5322 12H36.5122L34.7722 9.52L33.7322 10.62V12H32.8922ZM38.8283 12V6.7H39.5983L39.6283 8.05L39.5283 7.96C39.5949 7.64667 39.7149 7.39 39.8883 7.19C40.0683 6.98333 40.2816 6.83 40.5283 6.73C40.7749 6.63 41.0349 6.58 41.3083 6.58C41.7149 6.58 42.0516 6.67 42.3183 6.85C42.5916 7.03 42.7983 7.27333 42.9383 7.58C43.0783 7.88 43.1483 8.21667 43.1483 8.59V12H42.3083V8.83C42.3083 8.33667 42.2116 7.96333 42.0183 7.71C41.8249 7.45 41.5283 7.32 41.1283 7.32C40.8549 7.32 40.6083 7.38 40.3883 7.5C40.1683 7.61333 39.9916 7.78333 39.8583 8.01C39.7316 8.23 39.6683 8.50333 39.6683 8.83V12H38.8283ZM46.9844 12.12C46.4977 12.12 46.071 12.0067 45.7044 11.78C45.3444 11.5533 45.0644 11.2333 44.8644 10.82C44.6644 10.4 44.5644 9.91 44.5644 9.35C44.5644 8.78333 44.6644 8.29333 44.8644 7.88C45.0644 7.46667 45.3444 7.14667 45.7044 6.92C46.071 6.69333 46.4977 6.58 46.9844 6.58C47.471 6.58 47.8944 6.69333 48.2544 6.92C48.621 7.14667 48.9044 7.46667 49.1044 7.88C49.3044 8.29333 49.4044 8.78333 49.4044 9.35C49.4044 9.91 49.3044 10.4 49.1044 10.82C48.9044 11.2333 48.621 11.5533 48.2544 11.78C47.8944 12.0067 47.471 12.12 46.9844 12.12ZM46.9844 11.32C47.471 11.32 47.8477 11.1467 48.1144 10.8C48.3877 10.4467 48.5244 9.96333 48.5244 9.35C48.5244 8.73667 48.3877 8.25667 48.1144 7.91C47.8477 7.55667 47.471 7.38 46.9844 7.38C46.4977 7.38 46.1177 7.55667 45.8444 7.91C45.5777 8.25667 45.4444 8.73667 45.4444 9.35C45.4444 9.96333 45.5777 10.4467 45.8444 10.8C46.1177 11.1467 46.4977 11.32 46.9844 11.32ZM51.2305 12L50.1805 6.7H51.1005L51.7905 11.12L52.5705 7.44H53.3905L54.1705 11.12L54.8605 6.7H55.7805L54.7405 12H53.6805L52.9805 8.66L52.2805 12H51.2305ZM56.8166 12V6.7H57.5866L57.6166 8.05L57.5166 7.96C57.5832 7.64667 57.7032 7.39 57.8766 7.19C58.0566 6.98333 58.2699 6.83 58.5166 6.73C58.7632 6.63 59.0232 6.58 59.2966 6.58C59.7032 6.58 60.0399 6.67 60.3066 6.85C60.5799 7.03 60.7866 7.27333 60.9266 7.58C61.0666 7.88 61.1366 8.21667 61.1366 8.59V12H60.2966V8.83C60.2966 8.33667 60.1999 7.96333 60.0066 7.71C59.8132 7.45 59.5166 7.32 59.1166 7.32C58.8432 7.32 58.5966 7.38 58.3766 7.5C58.1566 7.61333 57.9799 7.78333 57.8466 8.01C57.7199 8.23 57.6566 8.50333 57.6566 8.83V12H56.8166Z'
        fill='#AD6800'
      />
    </svg>
  )
}

export function SelectIcon({ className }: Props) {
  return (
    <svg viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <g clipPath='url(#clip0_1088_1089)'>
        <path
          d='M30.0306 19.5306L22.5306 27.0306C22.4609 27.1003 22.3782 27.1557 22.2871 27.1934C22.1961 27.2312 22.0985 27.2506 21.9999 27.2506C21.9014 27.2506 21.8038 27.2312 21.7127 27.1934C21.6217 27.1557 21.539 27.1003 21.4693 27.0306L13.9693 19.5306C13.8286 19.3899 13.7495 19.199 13.7495 19C13.7495 18.801 13.8286 18.6101 13.9693 18.4694C14.11 18.3286 14.3009 18.2496 14.4999 18.2496C14.699 18.2496 14.8898 18.3286 15.0306 18.4694L21.9999 25.4397L28.9693 18.4694C29.039 18.3997 29.1217 18.3444 29.2128 18.3067C29.3038 18.269 29.4014 18.2496 29.4999 18.2496C29.5985 18.2496 29.6961 18.269 29.7871 18.3067C29.8781 18.3444 29.9609 18.3997 30.0306 18.4694C30.1002 18.539 30.1555 18.6218 30.1932 18.7128C30.2309 18.8039 30.2503 18.9014 30.2503 19C30.2503 19.0985 30.2309 19.1961 30.1932 19.2872C30.1555 19.3782 30.1002 19.4609 30.0306 19.5306Z'
          fill='#262626'
        />
      </g>
      <defs>
        <clipPath id='clip0_1088_1089'>
          <rect width='24' height='24' fill='white' transform='translate(10 10)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ConnectViaOauthIcon({ className }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path
        d='M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H7.33333C7.52222 2 7.68056 2.06389 7.80833 2.19167C7.93611 2.31944 8 2.47778 8 2.66667C8 2.85556 7.93611 3.01389 7.80833 3.14167C7.68056 3.26944 7.52222 3.33333 7.33333 3.33333H3.33333V12.6667H12.6667V8.66667C12.6667 8.47778 12.7306 8.31944 12.8583 8.19167C12.9861 8.06389 13.1444 8 13.3333 8C13.5222 8 13.6806 8.06389 13.8083 8.19167C13.9361 8.31944 14 8.47778 14 8.66667V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM12.6667 4.26667L6.93333 10C6.81111 10.1222 6.65556 10.1833 6.46667 10.1833C6.27778 10.1833 6.12222 10.1222 6 10C5.87778 9.87778 5.81667 9.72222 5.81667 9.53333C5.81667 9.34444 5.87778 9.18889 6 9.06667L11.7333 3.33333H10C9.81111 3.33333 9.65278 3.26944 9.525 3.14167C9.39722 3.01389 9.33333 2.85556 9.33333 2.66667C9.33333 2.47778 9.39722 2.31944 9.525 2.19167C9.65278 2.06389 9.81111 2 10 2H13.3333C13.5222 2 13.6806 2.06389 13.8083 2.19167C13.9361 2.31944 14 2.47778 14 2.66667V6C14 6.18889 13.9361 6.34722 13.8083 6.475C13.6806 6.60278 13.5222 6.66667 13.3333 6.66667C13.1444 6.66667 12.9861 6.60278 12.8583 6.475C12.7306 6.34722 12.6667 6.18889 12.6667 6V4.26667Z'
        fill='#262626'
      />
    </svg>
  )
}

export function AddApiKeyIcon({ className }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <g clipPath='url(#clip0_1157_1134)'>
        <path
          d='M11.3538 8.35375L6.35378 13.3538C6.30733 13.4002 6.25218 13.4371 6.19148 13.4622C6.13079 13.4873 6.06573 13.5003 6.00003 13.5003C5.93434 13.5003 5.86928 13.4873 5.80859 13.4622C5.74789 13.4371 5.69274 13.4002 5.64628 13.3538C5.59983 13.3073 5.56298 13.2521 5.53784 13.1915C5.5127 13.1308 5.49976 13.0657 5.49976 13C5.49976 12.9343 5.5127 12.8693 5.53784 12.8086C5.56298 12.7479 5.59983 12.6927 5.64628 12.6463L10.2932 8L5.64628 3.35375C5.55246 3.25993 5.49976 3.13269 5.49976 3C5.49976 2.86732 5.55246 2.74007 5.64628 2.64625C5.7401 2.55243 5.86735 2.49973 6.00003 2.49973C6.13272 2.49973 6.25996 2.55243 6.35378 2.64625L11.3538 7.64625C11.4003 7.69269 11.4372 7.74783 11.4623 7.80853C11.4875 7.86923 11.5004 7.9343 11.5004 8C11.5004 8.06571 11.4875 8.13077 11.4623 8.19147C11.4372 8.25217 11.4003 8.30732 11.3538 8.35375Z'
          fill='black'
          fillOpacity='0.88'
        />
      </g>
      <defs>
        <clipPath id='clip0_1157_1134'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ConnectButtonIcon({ className }: Props) {
  return (
    <svg
      width='10'
      height='6'
      viewBox='0 0 10 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M5.00004 4.29293L1.35359 0.646484L0.646484 1.35359L5.00004 5.70714L9.35359 1.35359L8.64648 0.646484L5.00004 4.29293Z'
        fill='#161513'
      />
    </svg>
  )
}

export function IsConnectedIcon({ className }: Props) {
  return (
    <svg
      width='8'
      height='8'
      viewBox='0 0 8 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle cx='4' cy='3.99995' r='4' fill='#36A764' />
    </svg>
  )
}

export function ConnectedIcon({ className }: Props) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_1211_2866)'>
        <path
          d='M10 6.25C9.25836 6.25 8.53333 6.46993 7.91665 6.88199C7.29996 7.29404 6.81932 7.87971 6.53549 8.56494C6.25166 9.25016 6.1774 10.0042 6.32209 10.7316C6.46679 11.459 6.82394 12.1272 7.34839 12.6516C7.87283 13.1761 8.54102 13.5332 9.26845 13.6779C9.99588 13.8226 10.7499 13.7484 11.4351 13.4645C12.1203 13.1807 12.706 12.7001 13.118 12.0834C13.5301 11.4667 13.75 10.7417 13.75 10C13.749 9.00575 13.3536 8.05253 12.6505 7.34949C11.9475 6.64645 10.9943 6.25103 10 6.25ZM10 12.5C9.50558 12.5 9.02223 12.3534 8.61111 12.0787C8.19999 11.804 7.87956 11.4135 7.69034 10.9567C7.50112 10.4999 7.45161 9.99723 7.54807 9.51227C7.64454 9.02732 7.88264 8.58186 8.23227 8.23223C8.5819 7.8826 9.02736 7.6445 9.51231 7.54803C9.99726 7.45157 10.4999 7.50108 10.9567 7.6903C11.4136 7.87952 11.804 8.19995 12.0787 8.61107C12.3534 9.0222 12.5 9.50555 12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.299 12.2366 10.6631 12.5 10 12.5ZM16.875 10.1687C16.8782 10.0562 16.8782 9.94375 16.875 9.83125L18.0407 8.375C18.1018 8.29854 18.1441 8.20879 18.1642 8.11299C18.1843 8.01719 18.1816 7.918 18.1563 7.82344C17.9652 7.10516 17.6794 6.41551 17.3063 5.77265C17.2574 5.68853 17.1896 5.61696 17.1082 5.56366C17.0269 5.51036 16.9342 5.47679 16.8375 5.46562L14.9844 5.25937C14.9073 5.17812 14.8292 5.1 14.75 5.025L14.5313 3.16719C14.52 3.07048 14.4863 2.97773 14.4329 2.89635C14.3795 2.81497 14.3077 2.74719 14.2235 2.69844C13.5804 2.32605 12.8908 2.04049 12.1727 1.84922C12.0781 1.82406 11.9788 1.82148 11.883 1.8417C11.7872 1.86192 11.6975 1.90437 11.6211 1.96562L10.1688 3.125C10.0563 3.125 9.94379 3.125 9.83129 3.125L8.37504 1.96172C8.29858 1.9006 8.20883 1.85829 8.11303 1.83821C8.01722 1.81813 7.91804 1.82083 7.82347 1.84609C7.10531 2.03752 6.4157 2.32334 5.77269 2.69609C5.68857 2.74494 5.617 2.81275 5.5637 2.89413C5.5104 2.97551 5.47683 3.0682 5.46566 3.16484L5.25941 5.02109C5.17816 5.0987 5.10004 5.17682 5.02504 5.25547L3.16722 5.46875C3.07051 5.48 2.97777 5.51369 2.89639 5.56713C2.815 5.62057 2.74723 5.69229 2.69847 5.77656C2.32609 6.41966 2.04053 7.10925 1.84925 7.82734C1.8241 7.92197 1.82152 8.02119 1.84174 8.11699C1.86196 8.2128 1.90441 8.30251 1.96566 8.3789L3.12504 9.83125C3.12504 9.94375 3.12504 10.0562 3.12504 10.1687L1.96175 11.625C1.90064 11.7015 1.85833 11.7912 1.83825 11.887C1.81816 11.9828 1.82086 12.082 1.84613 12.1766C2.03721 12.8948 2.32306 13.5845 2.69613 14.2273C2.74498 14.3115 2.81279 14.383 2.89417 14.4363C2.97555 14.4896 3.06824 14.5232 3.16488 14.5344L5.01801 14.7406C5.09561 14.8219 5.17373 14.9 5.25238 14.975L5.46879 16.8328C5.48004 16.9295 5.51373 17.0223 5.56717 17.1036C5.62061 17.185 5.69233 17.2528 5.7766 17.3016C6.4197 17.6739 7.10929 17.9595 7.82738 18.1508C7.92201 18.1759 8.02122 18.1785 8.11703 18.1583C8.21284 18.1381 8.30255 18.0956 8.37894 18.0344L9.83129 16.875C9.94379 16.8781 10.0563 16.8781 10.1688 16.875L11.625 18.0406C11.7015 18.1017 11.7912 18.144 11.887 18.1641C11.9828 18.1842 12.082 18.1815 12.1766 18.1562C12.8949 17.9652 13.5845 17.6793 14.2274 17.3062C14.3115 17.2574 14.3831 17.1896 14.4364 17.1082C14.4897 17.0268 14.5232 16.9341 14.5344 16.8375L14.7407 14.9844C14.8219 14.9073 14.9 14.8292 14.975 14.75L16.8329 14.5312C16.9296 14.52 17.0223 14.4863 17.1037 14.4329C17.1851 14.3794 17.2528 14.3077 17.3016 14.2234C17.674 13.5803 17.9595 12.8907 18.1508 12.1727C18.176 12.078 18.1786 11.9788 18.1583 11.883C18.1381 11.7872 18.0957 11.6975 18.0344 11.6211L16.875 10.1687ZM15.6172 9.66094C15.6305 9.88678 15.6305 10.1132 15.6172 10.3391C15.6079 10.4937 15.6564 10.6463 15.7532 10.7672L16.8618 12.1523C16.7345 12.5566 16.5717 12.9488 16.375 13.3242L14.6094 13.5242C14.4557 13.5413 14.3137 13.6148 14.211 13.7305C14.0606 13.8996 13.9004 14.0598 13.7313 14.2102C13.6156 14.3129 13.5421 14.4548 13.525 14.6086L13.3289 16.3727C12.9536 16.5694 12.5614 16.7323 12.1571 16.8594L10.7711 15.7508C10.6602 15.6622 10.5225 15.614 10.3805 15.6141H10.343C10.1172 15.6273 9.89073 15.6273 9.66488 15.6141C9.51026 15.6048 9.35769 15.6532 9.23676 15.75L7.84769 16.8594C7.44342 16.7322 7.05125 16.5693 6.67582 16.3727L6.47582 14.6094C6.45875 14.4556 6.38526 14.3136 6.26957 14.2109C6.10043 14.0606 5.94026 13.9004 5.78988 13.7312C5.68717 13.6156 5.5452 13.5421 5.39144 13.525L3.62738 13.3281C3.43065 12.9527 3.26777 12.5606 3.14066 12.1562L4.24925 10.7703C4.34606 10.6494 4.3945 10.4968 4.38519 10.3422C4.37191 10.1163 4.37191 9.88991 4.38519 9.66406C4.3945 9.50944 4.34606 9.35687 4.24925 9.23594L3.14066 7.84765C3.26787 7.44338 3.43075 7.05122 3.62738 6.67578L5.39066 6.47578C5.54442 6.45871 5.68639 6.38522 5.7891 6.26953C5.93948 6.1004 6.09965 5.94022 6.26879 5.78984C6.38494 5.68707 6.45873 5.54477 6.47582 5.39062L6.67191 3.62734C7.0473 3.43062 7.43948 3.26773 7.84379 3.14062L9.22972 4.24922C9.35066 4.34602 9.50323 4.39446 9.65785 4.38515C9.8837 4.37187 10.1101 4.37187 10.336 4.38515C10.4906 4.39446 10.6432 4.34602 10.7641 4.24922L12.1524 3.14062C12.5567 3.26783 12.9488 3.43071 13.3243 3.62734L13.5243 5.39062C13.5413 5.54438 13.6148 5.68635 13.7305 5.78906C13.8996 5.93944 14.0598 6.09961 14.2102 6.26875C14.3129 6.38444 14.4549 6.45793 14.6086 6.475L16.3727 6.67109C16.5694 7.04648 16.7323 7.43866 16.8594 7.84297L15.7508 9.2289C15.6531 9.35085 15.6046 9.505 15.6149 9.66094H15.6172Z'
          fill='black'
          fillOpacity='0.45'
        />
      </g>
      <defs>
        <clipPath id='clip0_1211_2866'>
          <rect width='20' height='20' rx='8' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function MoreIcon({ className }: Props) {
  return (
    <svg
      width='4'
      height='12'
      viewBox='0 0 4 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M1.99996 11.3333C1.63329 11.3333 1.3194 11.2028 1.05829 10.9417C0.797182 10.6805 0.666626 10.3667 0.666626 9.99999C0.666626 9.63332 0.797182 9.31943 1.05829 9.05832C1.3194 8.79721 1.63329 8.66666 1.99996 8.66666C2.36663 8.66666 2.68051 8.79721 2.94163 9.05832C3.20274 9.31943 3.33329 9.63332 3.33329 9.99999C3.33329 10.3667 3.20274 10.6805 2.94163 10.9417C2.68051 11.2028 2.36663 11.3333 1.99996 11.3333ZM1.99996 7.33332C1.63329 7.33332 1.3194 7.20277 1.05829 6.94166C0.797182 6.68055 0.666626 6.36666 0.666626 5.99999C0.666626 5.63332 0.797182 5.31943 1.05829 5.05832C1.3194 4.79721 1.63329 4.66666 1.99996 4.66666C2.36663 4.66666 2.68051 4.79721 2.94163 5.05832C3.20274 5.31943 3.33329 5.63332 3.33329 5.99999C3.33329 6.36666 3.20274 6.68055 2.94163 6.94166C2.68051 7.20277 2.36663 7.33332 1.99996 7.33332ZM1.99996 3.33332C1.63329 3.33332 1.3194 3.20277 1.05829 2.94166C0.797182 2.68055 0.666626 2.36666 0.666626 1.99999C0.666626 1.63332 0.797182 1.31943 1.05829 1.05832C1.3194 0.797212 1.63329 0.666656 1.99996 0.666656C2.36663 0.666656 2.68051 0.797212 2.94163 1.05832C3.20274 1.31943 3.33329 1.63332 3.33329 1.99999C3.33329 2.36666 3.20274 2.68055 2.94163 2.94166C2.68051 3.20277 2.36663 3.33332 1.99996 3.33332Z'
        fill='#79747E'
      />
    </svg>
  )
}

export function ExampleIcon({ className }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path
        d='M4.87713 9.24161C4.92557 9.29005 5.00526 9.29005 5.0537 9.24161L6.64432 7.65099L7.98964 8.99786C8.03807 9.0463 8.11776 9.0463 8.1662 8.99786L11.7021 5.4588C11.7506 5.41036 11.7506 5.33067 11.7021 5.28224L11.1271 4.70723C11.0787 4.6588 10.999 4.6588 10.9506 4.70723L8.0787 7.58224L6.73339 6.23536C6.68495 6.18692 6.60526 6.18692 6.55682 6.23536L4.30213 8.49005C4.2537 8.53849 4.2537 8.61817 4.30213 8.66661L4.87713 9.24161Z'
        fill='black'
        fillOpacity='0.88'
      />
      <path
        d='M14.125 2.5H8.5625V1.5C8.5625 1.43125 8.50625 1.375 8.4375 1.375H7.5625C7.49375 1.375 7.4375 1.43125 7.4375 1.5V2.5H1.875C1.59844 2.5 1.375 2.72344 1.375 3V11.125C1.375 11.4016 1.59844 11.625 1.875 11.625H7.44375V12.125L4.86875 13.8141C4.81094 13.8516 4.79531 13.9281 4.83281 13.9859L5.30625 14.7234V14.725C5.34375 14.7828 5.42188 14.7984 5.47969 14.7609L8 13.1078L10.5203 14.7609C10.5781 14.7984 10.6563 14.7828 10.6938 14.725V14.7234L11.1672 13.9859C11.2047 13.9281 11.1875 13.8516 11.1313 13.8141L8.5625 12.1297V11.625H14.125C14.4016 11.625 14.625 11.4016 14.625 11.125V3C14.625 2.72344 14.4016 2.5 14.125 2.5ZM13.5 10.5H2.5V3.625H13.5V10.5Z'
        fill='black'
        fillOpacity='0.88'
      />
    </svg>
  )
}

export function PlusIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon / PlusOutlined'>
        <g id='Vector'>
          <path
            d='M7.53125 2.37498H8.46875C8.55208 2.37498 8.59375 2.41665 8.59375 2.49998V13.5C8.59375 13.5833 8.55208 13.625 8.46875 13.625H7.53125C7.44792 13.625 7.40625 13.5833 7.40625 13.5V2.49998C7.40625 2.41665 7.44792 2.37498 7.53125 2.37498Z'
            fill='black'
            fillOpacity='0.88'
          />
          <path
            d='M2.75 7.40623H13.25C13.3333 7.40623 13.375 7.4479 13.375 7.53123V8.46873C13.375 8.55207 13.3333 8.59373 13.25 8.59373H2.75C2.66667 8.59373 2.625 8.55207 2.625 8.46873V7.53123C2.625 7.4479 2.66667 7.40623 2.75 7.40623Z'
            fill='black'
            fillOpacity='0.88'
          />
        </g>
      </g>
    </svg>
  )
}

export function CaretLeftIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='icon/caret-down' clipPath='url(#clip0_1_11654)'>
        <path
          id='Vector'
          d='M9.64646 13.3538L4.64646 8.35375C4.59997 8.30732 4.56309 8.25217 4.53793 8.19147C4.51277 8.13077 4.49982 8.06571 4.49982 8C4.49982 7.9343 4.51277 7.86923 4.53793 7.80853C4.56309 7.74783 4.59997 7.69269 4.64646 7.64625L9.64646 2.64625C9.74028 2.55243 9.86753 2.49973 10.0002 2.49973C10.1329 2.49973 10.2601 2.55243 10.354 2.64625C10.4478 2.74007 10.5005 2.86732 10.5005 3C10.5005 3.13269 10.4478 3.25993 10.354 3.35375L5.70709 8L10.354 12.6463C10.4004 12.6927 10.4373 12.7479 10.4624 12.8086C10.4875 12.8693 10.5005 12.9343 10.5005 13C10.5005 13.0657 10.4875 13.1308 10.4624 13.1915C10.4373 13.2521 10.4004 13.3073 10.354 13.3538C10.3075 13.4002 10.2524 13.4371 10.1917 13.4622C10.131 13.4873 10.0659 13.5003 10.0002 13.5003C9.93451 13.5003 9.86946 13.4873 9.80876 13.4622C9.74807 13.4371 9.69292 13.4002 9.64646 13.3538Z'
          fill='#2E1F36'
        />
      </g>
      <defs>
        <clipPath id='clip0_1_11654'>
          <rect width='16' height='16' fill='white' transform='matrix(0 1 -1 0 16 0)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function HomeIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon / HomeOutlined'>
        <path
          id='Vector'
          d='M14.7894 7.89152L8.75192 1.85714L8.34723 1.45246C8.25502 1.36086 8.13033 1.30945 8.00036 1.30945C7.87039 1.30945 7.74569 1.36086 7.65348 1.45246L1.2113 7.89152C1.11681 7.98563 1.04214 8.09772 0.991689 8.22117C0.941237 8.34462 0.916026 8.47692 0.917545 8.61027C0.923795 9.16027 1.38161 9.59933 1.93161 9.59933H2.59567V14.6884H13.405V9.59933H14.0832C14.3504 9.59933 14.6019 9.49464 14.791 9.30558C14.8841 9.21279 14.9578 9.10245 15.008 8.98095C15.0581 8.85945 15.0837 8.72921 15.0832 8.59777C15.0832 8.33214 14.9785 8.08058 14.7894 7.89152ZM8.87536 13.5634H7.12536V10.3759H8.87536V13.5634ZM12.28 8.47433V13.5634H9.87536V10.0009C9.87536 9.65558 9.59567 9.37589 9.25036 9.37589H6.75036C6.40505 9.37589 6.12536 9.65558 6.12536 10.0009V13.5634H3.72067V8.47433H2.22067L8.00192 2.69777L8.36286 3.05871L13.7816 8.47433H12.28Z'
          fill='currentColor'
          fillOpacity='0.88'
        />
      </g>
    </svg>
  )
}

export function CheckIconTwoTone({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon / CheckCircleTwoTone'>
        <path
          id='Vector'
          d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8 13.8125C4.79063 13.8125 2.1875 11.2094 2.1875 8C2.1875 4.79063 4.79063 2.1875 8 2.1875C11.2094 2.1875 13.8125 4.79063 13.8125 8C13.8125 11.2094 11.2094 13.8125 8 13.8125Z'
          fill='#AC99FF'
        />
        <g id='Vector_2' opacity='0.1'>
          <path
            d='M8 2.1875C4.79063 2.1875 2.1875 4.79063 2.1875 8C2.1875 11.2094 4.79063 13.8125 8 13.8125C11.2094 13.8125 13.8125 11.2094 13.8125 8C13.8125 4.79063 11.2094 2.1875 8 2.1875ZM11.0219 5.71406L7.73125 10.2766C7.68526 10.3408 7.62463 10.3931 7.55439 10.4291C7.48414 10.4652 7.40631 10.4841 7.32734 10.4841C7.24838 10.4841 7.17054 10.4652 7.1003 10.4291C7.03006 10.3931 6.96943 10.3408 6.92344 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97187 7.37813 6.12187 7.45625 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59219 10.0297 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0219 5.71406Z'
            fill='url(#paint0_linear_46_1347)'
          />
          <path
            d='M8 2.1875C4.79063 2.1875 2.1875 4.79063 2.1875 8C2.1875 11.2094 4.79063 13.8125 8 13.8125C11.2094 13.8125 13.8125 11.2094 13.8125 8C13.8125 4.79063 11.2094 2.1875 8 2.1875ZM11.0219 5.71406L7.73125 10.2766C7.68526 10.3408 7.62463 10.3931 7.55439 10.4291C7.48414 10.4652 7.40631 10.4841 7.32734 10.4841C7.24838 10.4841 7.17054 10.4652 7.1003 10.4291C7.03006 10.3931 6.96943 10.3408 6.92344 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97187 7.37813 6.12187 7.45625 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59219 10.0297 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0219 5.71406Z'
            fill='black'
            fillOpacity='0.2'
          />
        </g>
        <path
          id='Vector_3'
          d='M10.9211 5.51562H10.1883C10.0289 5.51562 9.87736 5.59219 9.78361 5.72344L7.32735 9.12969L6.21485 7.58594C6.1211 7.45625 5.9711 7.37813 5.81016 7.37813H5.07735C4.97578 7.37813 4.91641 7.49375 4.97578 7.57656L6.92267 10.2766C6.96866 10.3408 7.02929 10.3931 7.09953 10.4291C7.16977 10.4652 7.2476 10.4841 7.32657 10.4841C7.40554 10.4841 7.48337 10.4652 7.55362 10.4291C7.62386 10.3931 7.68449 10.3408 7.73048 10.2766L11.0211 5.71406C11.0821 5.63125 11.0227 5.51562 10.9211 5.51562Z'
          fill='#AC99FF'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_46_1347'
          x1='2.1875'
          y1='8'
          x2='13.8125'
          y2='8'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='1' stopColor='#F9F1F7' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function ChatSidebarIcon({ className }: Props) {
  return (
    <svg
      stroke='currentColor'
      fill='currentColor'
      strokeWidth='0'
      width='16'
      height='16'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='icon/bookmark' fill='#AB97FE'>
        <path d='M5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455Z'></path>
      </g>
    </svg>
  )
}

export function ErroredSidebarIcon({ className }: Props) {
  return (
    <svg
      stroke='currentColor'
      fill='none'
      strokeWidth='0'
      viewBox='0 0 15 15'
      height='16'
      width='16'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z'
        fill='#EA462D'
      ></path>
    </svg>
  )
}

export function ProgressCircleIcon({ className }: Props) {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Progress Circle'>
        <circle
          id='Ellipse 1'
          cx='7'
          cy='7'
          r='6'
          stroke='black'
          strokeOpacity='0.06'
          strokeWidth='2'
        />
        <path
          id='Ellipse 2'
          d='M7 1.00003C8.18669 1.00003 9.34673 1.35192 10.3334 2.01121C11.3201 2.6705 12.0892 3.60757 12.5433 4.70393C12.9974 5.80029 13.1162 7.00669 12.8847 8.17057C12.6532 9.33446 12.0818 10.4036 11.2426 11.2427C10.4035 12.0818 9.33443 12.6532 8.17054 12.8847C7.00666 13.1163 5.80026 12.9974 4.7039 12.5433C3.60754 12.0892 2.67047 11.3201 2.01118 10.3335C1.35189 9.34676 1 8.18672 1 7.00003'
          stroke='#808080'
          strokeOpacity='0.55'
          strokeWidth='2'
        />
      </g>
    </svg>
  )
}

export function TestConnectionIcon({ className }: Props) {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_927_5431)'>
        <path
          d='M7 14C6.05527 14 5.13789 13.8154 4.2752 13.4504C3.44121 13.0977 2.69336 12.5918 2.05078 11.9492C1.4082 11.3066 0.902344 10.5588 0.549609 9.7248C0.18457 8.86211 0 7.94473 0 7C0 6.72793 0.220117 6.50781 0.492188 6.50781C0.764258 6.50781 0.984375 6.72793 0.984375 7C0.984375 7.81211 1.14297 8.59961 1.45742 9.34199C1.76094 10.0584 2.19434 10.7023 2.74668 11.2547C3.29902 11.807 3.94297 12.2418 4.65937 12.5439C5.40039 12.857 6.18789 13.0156 7 13.0156C7.81211 13.0156 8.59961 12.857 9.34199 12.5426C10.0584 12.2391 10.7023 11.8057 11.2547 11.2533C11.807 10.701 12.2418 10.057 12.5439 9.34062C12.857 8.59961 13.0156 7.81211 13.0156 7C13.0156 6.18789 12.857 5.40039 12.5426 4.65801C12.2401 3.94332 11.8023 3.29384 11.2533 2.74531C10.7054 2.19559 10.0558 1.7577 9.34062 1.45605C8.59961 1.14297 7.81211 0.984375 7 0.984375C6.72793 0.984375 6.50781 0.764258 6.50781 0.492188C6.50781 0.220117 6.72793 0 7 0C7.94473 0 8.86211 0.18457 9.7248 0.549609C10.5588 0.902344 11.3066 1.4082 11.9492 2.05078C12.5918 2.69336 13.0963 3.44258 13.449 4.2752C13.8141 5.13789 13.9986 6.05527 13.9986 7C13.9986 7.94473 13.8141 8.86211 13.449 9.7248C13.0977 10.5588 12.5918 11.3066 11.9492 11.9492C11.3066 12.5918 10.5574 13.0963 9.7248 13.449C8.86211 13.8154 7.94473 14 7 14Z'
          fill='#AC99FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_927_5431'>
          <rect width='14' height='14' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function TestConnectionSuccessIcon({ className }: Props) {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3698 3.91249L5.24897 11.0333L1.33649 7.12082L2.16144 6.29586L5.24897 9.38338L11.5448 3.08753L12.3698 3.91249Z'
        fill='url(#paint0_linear_927_5659)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3698 3.91249L5.24897 11.0333L1.33649 7.12082L2.16144 6.29586L5.24897 9.38338L11.5448 3.08753L12.3698 3.91249Z'
        fill='black'
        fillOpacity='0.2'
      />
      <defs>
        <linearGradient
          id='paint0_linear_927_5659'
          x1='1.33649'
          y1='7.06041'
          x2='12.3698'
          y2='7.06041'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='1' stopColor='#F9F1F7' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function ConnectionFailedIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g id='Icon'>
        <path
          id='vector'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.99967 2.33337L14.6663 14.3334H1.33301L7.99967 2.33337ZM7.33301 10.3334H8.66634V7.66671H7.33301V10.3334ZM7.33301 11V12.3334H8.66634V11H7.33301Z'
          fill='#ea462c'
        />
      </g>
    </svg>
  )
}

export function TooltipIcon({ className }: Props) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M12 1.49998C6.20156 1.49998 1.5 6.20155 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20155 17.7984 1.49998 12 1.49998ZM12 20.7187C7.18594 20.7187 3.28125 16.814 3.28125 12C3.28125 7.18592 7.18594 3.28123 12 3.28123C16.8141 3.28123 20.7188 7.18592 20.7188 12C20.7188 16.814 16.8141 20.7187 12 20.7187Z'
        fill='black'
        fillOpacity='0.45'
      />
      <path
        d='M10.875 7.87498C10.875 8.17335 10.9935 8.4595 11.2045 8.67048C11.4155 8.88146 11.7016 8.99998 12 8.99998C12.2984 8.99998 12.5845 8.88146 12.7955 8.67048C13.0065 8.4595 13.125 8.17335 13.125 7.87498C13.125 7.57662 13.0065 7.29047 12.7955 7.07949C12.5845 6.86851 12.2984 6.74998 12 6.74998C11.7016 6.74998 11.4155 6.86851 11.2045 7.07949C10.9935 7.29047 10.875 7.57662 10.875 7.87498ZM12.5625 10.5H11.4375C11.3344 10.5 11.25 10.5844 11.25 10.6875V17.0625C11.25 17.1656 11.3344 17.25 11.4375 17.25H12.5625C12.6656 17.25 12.75 17.1656 12.75 17.0625V10.6875C12.75 10.5844 12.6656 10.5 12.5625 10.5Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function AddSectionIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.75 9.75H4.25V8.25H8.75V3.75H10.25V8.25H14.75V9.75H10.25V14.25H8.75V9.75Z'
        fill='black'
        fillOpacity='0.88'
      />
    </svg>
  )
}

export function TopSectionInfoIcon({ className }: Props) {
  return (
    <svg
      width='18'
      className={className}
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.24854 1.5H10.0592L12.7485 4.18934V5.25H13.0592L15.7485 7.93934V16.5H5.24854V13.5H2.24854V1.5ZM11.2485 12V4.81066L9.43788 3H3.74854V12H11.2485ZM6.74854 13.5V15H14.2485V8.56066L12.7485 7.06066V13.5H6.74854ZM8.24854 6.75H5.24854V5.25H8.24854V6.75ZM9.74854 9.75H5.24854V8.25H9.74854V9.75Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function TopSectionNavDownIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.0001 14.5858L4.70718 7.29291L3.29297 8.70712L12.0001 17.4142L20.7072 8.70712L19.293 7.29291L12.0001 14.5858Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function TopSectionNavUpIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.5001 9.41424L19.793 16.7071L21.2072 15.2929L12.5001 6.58582L3.79297 15.2929L5.20718 16.7071L12.5001 9.41424Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function PDFIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.0223 5.0748C15.1277 5.18027 15.1875 5.32266 15.1875 5.47207V16.3125C15.1875 16.6236 14.9361 16.875 14.625 16.875H3.375C3.06387 16.875 2.8125 16.6236 2.8125 16.3125V1.6875C2.8125 1.37637 3.06387 1.125 3.375 1.125H10.8404C10.9898 1.125 11.134 1.18477 11.2395 1.29023L15.0223 5.0748V5.0748ZM13.8902 5.73047L10.582 2.42227V5.73047H13.8902ZM11.1308 11.2018C10.864 11.193 10.5803 11.2136 10.2581 11.2539C9.83092 10.9904 9.54334 10.6284 9.33908 10.0967L9.35789 10.0197L9.37969 9.92865C9.45527 9.60996 9.49588 9.3774 9.50801 9.14291C9.51715 8.9659 9.5073 8.8026 9.47584 8.65125C9.41783 8.32447 9.18668 8.1334 8.89541 8.12162C8.62383 8.11055 8.37422 8.26225 8.31041 8.49727C8.20652 8.8773 8.26734 9.3774 8.4876 10.2303C8.20705 10.8991 7.83633 11.6833 7.5876 12.1206C7.25555 12.2919 6.99697 12.4476 6.77971 12.6202C6.49318 12.8482 6.31424 13.0825 6.26502 13.3286C6.24111 13.4427 6.27715 13.5918 6.35924 13.7139C6.4524 13.8524 6.59268 13.9424 6.7609 13.9554C7.18541 13.9883 7.70713 13.5506 8.28316 12.5622C8.341 12.5429 8.40217 12.5225 8.47687 12.4972L8.68605 12.4265C8.81842 12.3819 8.9144 12.3499 9.00932 12.3191C9.42065 12.1852 9.73178 12.1006 10.0148 12.0524C10.5066 12.3158 11.0751 12.4884 11.4579 12.4884C11.774 12.4884 11.9876 12.3246 12.0647 12.0667C12.1324 11.8403 12.0788 11.5777 11.9333 11.4325C11.7828 11.2846 11.5061 11.214 11.1308 11.2018V11.2018ZM6.77162 13.4592V13.4529L6.77391 13.4469C6.79963 13.3804 6.83264 13.317 6.87234 13.2578C6.94758 13.1421 7.05111 13.0205 7.17943 12.8909C7.24834 12.8215 7.32006 12.7538 7.40426 12.6779C7.42307 12.661 7.5433 12.5539 7.5658 12.5329L7.76215 12.35L7.61941 12.5773C7.40285 12.9226 7.20703 13.1711 7.03934 13.3332C6.97764 13.3929 6.92332 13.4369 6.87937 13.4652C6.86487 13.4749 6.84951 13.4832 6.8335 13.4902C6.82629 13.4931 6.81996 13.4949 6.81363 13.4954C6.80695 13.4963 6.80017 13.4954 6.79395 13.4928C6.78733 13.49 6.78168 13.4854 6.77771 13.4794C6.77374 13.4734 6.77162 13.4664 6.77162 13.4592V13.4592ZM8.98541 9.62227L8.94568 9.69258L8.92107 9.61559C8.86658 9.44279 8.8265 9.18246 8.81543 8.94762C8.80277 8.68043 8.82404 8.52012 8.90842 8.52012C9.02689 8.52012 9.08121 8.70996 9.08543 8.99561C9.0893 9.24662 9.04975 9.50783 8.98523 9.62227H8.98541ZM8.88328 10.6499L8.91018 10.5787L8.94691 10.6455C9.1524 11.0188 9.41906 11.3303 9.71227 11.5474L9.77555 11.5942L9.69838 11.61C9.41133 11.6694 9.14397 11.7587 8.77834 11.9062C8.81648 11.8907 8.3983 12.0619 8.29248 12.1025L8.2002 12.1379L8.24941 12.0521C8.4665 11.6742 8.66707 11.2203 8.88311 10.6499H8.88328ZM11.6539 11.9904C11.5158 12.0449 11.2184 11.9962 10.6947 11.7726L10.5618 11.716L10.706 11.7054C11.1155 11.675 11.4056 11.6975 11.5747 11.7594C11.6467 11.7858 11.6947 11.819 11.716 11.857C11.7272 11.8749 11.731 11.8966 11.7265 11.9173C11.722 11.938 11.7097 11.9561 11.6921 11.9679C11.6809 11.9777 11.668 11.9854 11.6539 11.9904V11.9904Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function GenerateButtonAiIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.08425 11.0844L8.55114 6.68377H10.4485L11.9154 11.0844L16.316 12.5513V14.4487L11.9154 15.9156L10.4485 20.3162H8.55114L7.08425 15.9156L2.68359 14.4487V12.5513L7.08425 11.0844ZM9.49982 10.1623L8.8235 12.1912L8.19105 12.8237L6.1621 13.5L8.19105 14.1763L8.8235 14.8088L9.49982 16.8377L10.1761 14.8088L10.8086 14.1763L12.8375 13.5L10.8086 12.8237L10.1761 12.1912L9.49982 10.1623Z'
        fill='url(#paint0_linear_680_8424)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.1505 5.15066L16.9306 2.81026H18.069L18.8492 5.15066L21.1896 5.93079V7.06921L18.8492 7.84934L18.069 10.1897H16.9306L16.1505 7.84934L13.8101 7.06921V5.93079L16.1505 5.15066Z'
        fill='url(#paint1_linear_680_8424)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_680_8424'
          x1='2.68359'
          y1='11.5632'
          x2='21.1896'
          y2='11.5632'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_680_8424'
          x1='2.68359'
          y1='11.5632'
          x2='21.1896'
          y2='11.5632'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function AssistantIcon({ className }: Props) {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <rect x='0.75' y='0.75' width='30.5' height='30.5' rx='15.25' fill='#F9F1F8' />
      <rect
        x='0.75'
        y='0.75'
        width='30.5'
        height='30.5'
        rx='15.25'
        stroke='url(#paint0_linear_329_37009)'
        strokeWidth='1.5'
      />
      <path
        d='M15.3336 10.6666C13.3718 10.6666 11.8002 12.2283 11.8002 14.1319C11.8002 15.3278 12.4179 16.3863 13.3669 17.0112L13.6669 17.2088V18.9305H12.3336C11.7747 18.9305 11.4386 19.0578 11.2283 19.2074C11.0186 19.3566 10.8716 19.5724 10.7703 19.8626C10.6158 20.3053 10.5942 20.8166 10.5952 21.3333H13.3336V22.6666H9.26689V21.9999C9.26689 21.918 9.26542 21.8256 9.26382 21.7247C9.25416 21.1173 9.2396 20.2021 9.51148 19.4232C9.67934 18.9423 9.96688 18.4686 10.4553 18.121C10.8661 17.8287 11.3745 17.6573 11.9812 17.6104C11.2041 16.8819 10.6689 15.901 10.5135 14.7985H9.33356V13.4652H10.5134C10.8429 11.1231 12.8839 9.33325 15.3336 9.33325C17.7833 9.33325 19.8242 11.1231 20.1537 13.4652H21.3336V14.7985H20.2002V15.3124H18.8669V14.1319C18.8669 12.2283 17.2953 10.6666 15.3336 10.6666ZM14.2002 15.3124H12.8669V12.9513H14.2002V15.3124ZM17.8002 15.3124H16.4669V12.9513H17.8002V15.3124ZM19.0002 17.9999C18.0798 17.9999 17.3336 18.7461 17.3336 19.6666C17.3336 20.5871 18.0798 21.3333 19.0002 21.3333H20.0002V17.9999H19.0002ZM21.3336 19.3333V19.9999H22.6669V21.3333H21.3336V22.6666H19.0002C17.5725 22.6666 16.3777 21.6692 16.0746 20.3333H14.6669V18.9999H16.0746C16.3777 17.6639 17.5725 16.6666 19.0002 16.6666H21.3336V17.9999H22.6669V19.3333H21.3336Z'
        fill='url(#paint1_linear_329_37009)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_329_37009'
          x1='0'
          y1='16'
          x2='32'
          y2='16'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_329_37009'
          x1='9.25977'
          y1='15.9999'
          x2='22.6669'
          y2='15.9999'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function UploadIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.9985 10.5H19.8092L23.9985 14.6893V19.5H22.4985V15.75H18.7485V12H13.4985V24H19.4985V25.5H11.9985V10.5ZM20.2485 13.0607V14.25H21.4379L20.2485 13.0607ZM22.4985 24V25.5H23.9985V24H25.4985V22.5H23.9985V21H22.4985V22.5H20.9985V24H22.4985Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function SuccessStateIcon({ className }: Props) {
  return (
    <svg
      width='6'
      height='6'
      viewBox='0 0 6 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle cx='3' cy='3' r='3' fill='#52C41A' />
    </svg>
  )
}

export function SettingsIcon({ className }: Props) {
  return (
    <svg
      width='13'
      height='14'
      viewBox='0 0 13 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.86291 12.1051V13.5H3.86291L3.86291 12.0887C5.14019 11.8307 6.09204 10.6824 6.09204 9.32139C6.09204 7.96041 5.14019 6.81212 3.86291 6.55413L3.86291 0.5H2.86291V6.53771C1.54117 6.75928 0.544922 7.92903 0.544922 9.32139C0.544922 10.7138 1.54117 11.8835 2.86291 12.1051ZM1.54492 9.32139C1.54492 10.3372 2.34874 11.1428 3.31848 11.1428C4.28822 11.1428 5.09204 10.3372 5.09204 9.32139C5.09204 8.30557 4.28822 7.49997 3.31848 7.49997C2.34874 7.49997 1.54492 8.30557 1.54492 9.32139Z'
        fill='black'
      />
      <path
        d='M2.86291 12.1051H3.01291C3.01291 12.0318 2.95997 11.9693 2.88771 11.9571L2.86291 12.1051ZM2.86291 13.5H2.71291C2.71291 13.5828 2.78007 13.65 2.86291 13.65V13.5ZM3.86291 13.5V13.65C3.94575 13.65 4.01291 13.5828 4.01291 13.5H3.86291ZM3.86291 12.0887L3.83321 11.9416C3.76323 11.9558 3.71291 12.0173 3.71291 12.0887H3.86291ZM3.86291 6.55413H3.71291C3.71291 6.62552 3.76323 6.68703 3.83321 6.70116L3.86291 6.55413ZM3.86291 0.5L4.01291 0.5C4.01291 0.460218 3.99711 0.422064 3.96898 0.393934C3.94085 0.365804 3.90269 0.35 3.86291 0.35V0.5ZM2.86291 0.5V0.35C2.78007 0.35 2.71291 0.417157 2.71291 0.5H2.86291ZM2.86291 6.53771L2.88771 6.68565C2.95997 6.67353 3.01291 6.61098 3.01291 6.53771H2.86291ZM2.71291 12.1051V13.5H3.01291V12.1051H2.71291ZM2.86291 13.65H3.86291V13.35H2.86291V13.65ZM4.01291 13.5L4.01291 12.0887H3.71291L3.71291 13.5H4.01291ZM3.89261 12.2357C5.24075 11.9634 6.24204 10.7529 6.24204 9.32139H5.94204C5.94204 10.6119 5.03962 11.6979 3.83321 11.9416L3.89261 12.2357ZM6.24204 9.32139C6.24204 7.88992 5.24075 6.67941 3.89261 6.4071L3.83321 6.70116C5.03962 6.94484 5.94204 8.0309 5.94204 9.32139H6.24204ZM4.01291 6.55413L4.01291 0.5L3.71291 0.5L3.71291 6.55413H4.01291ZM3.86291 0.35H2.86291V0.65H3.86291V0.35ZM2.71291 0.5V6.53771H3.01291V0.5H2.71291ZM2.83811 6.38978C1.4429 6.62366 0.394922 7.85699 0.394922 9.32139H0.694922C0.694922 8.00108 1.63944 6.8949 2.88771 6.68565L2.83811 6.38978ZM0.394922 9.32139C0.394922 10.7858 1.4429 12.0191 2.83811 12.253L2.88771 11.9571C1.63944 11.7479 0.694922 10.6417 0.694922 9.32139H0.394922ZM3.31848 10.9928C2.43427 10.9928 1.69492 10.2571 1.69492 9.32139H1.39492C1.39492 10.4173 2.26321 11.2928 3.31848 11.2928V10.9928ZM4.94204 9.32139C4.94204 10.2571 4.20269 10.9928 3.31848 10.9928V11.2928C4.37375 11.2928 5.24204 10.4173 5.24204 9.32139H4.94204ZM3.31848 7.64997C4.20269 7.64997 4.94204 8.3857 4.94204 9.32139H5.24204C5.24204 8.22544 4.37375 7.34997 3.31848 7.34997V7.64997ZM1.69492 9.32139C1.69492 8.3857 2.43427 7.64997 3.31848 7.64997V7.34997C2.26321 7.34997 1.39492 8.22544 1.39492 9.32139H1.69492Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2263 1.91114C11.504 2.1688 12.4563 3.31729 12.4563 4.67857C12.4563 6.03985 11.504 7.18835 10.2263 7.44601L10.2263 13.5H9.22633V7.46211C7.90501 7.24018 6.90918 6.07064 6.90918 4.67857C6.90918 3.28651 7.90501 2.11696 9.22633 1.89503V0.5H10.2263V1.91114ZM7.90918 4.67857C7.90918 5.69439 8.713 6.5 9.68274 6.5C10.6525 6.5 11.4563 5.69439 11.4563 4.67857C11.4563 3.66275 10.6525 2.85714 9.68274 2.85714C8.713 2.85714 7.90918 3.66275 7.90918 4.67857Z'
        fill='black'
      />
      <path
        d='M10.2263 1.91114H10.0763C10.0763 1.98255 10.1267 2.04406 10.1967 2.05818L10.2263 1.91114ZM10.2263 7.44601L10.1967 7.29897C10.1267 7.31308 10.0763 7.37459 10.0763 7.44601H10.2263ZM10.2263 13.5V13.65C10.2661 13.65 10.3043 13.6342 10.3324 13.6061C10.3605 13.5779 10.3763 13.5398 10.3763 13.5H10.2263ZM9.22633 13.5H9.07633C9.07633 13.5828 9.14348 13.65 9.22633 13.65V13.5ZM9.22633 7.46211H9.37633C9.37633 7.38886 9.32341 7.32632 9.25117 7.31418L9.22633 7.46211ZM9.22633 1.89503L9.25117 2.04296C9.32341 2.03083 9.37633 1.96829 9.37633 1.89503H9.22633ZM9.22633 0.5V0.35C9.14348 0.35 9.07633 0.417157 9.07633 0.5H9.22633ZM10.2263 0.5H10.3763C10.3763 0.417157 10.3092 0.35 10.2263 0.35V0.5ZM12.6063 4.67857C12.6063 3.24679 11.6046 2.03605 10.256 1.7641L10.1967 2.05818C11.4035 2.30154 12.3063 3.3878 12.3063 4.67857H12.6063ZM10.256 7.59305C11.6046 7.32109 12.6063 6.11036 12.6063 4.67857H12.3063C12.3063 5.96935 11.4035 7.0556 10.1967 7.29897L10.256 7.59305ZM10.3763 13.5L10.3763 7.44601H10.0763L10.0763 13.5H10.3763ZM9.22633 13.65H10.2263V13.35H9.22633V13.65ZM9.07633 7.46211V13.5H9.37633V7.46211H9.07633ZM6.75918 4.67857C6.75918 6.14267 7.80672 7.37578 9.20148 7.61004L9.25117 7.31418C8.0033 7.10459 7.05918 5.99861 7.05918 4.67857H6.75918ZM9.20148 1.7471C7.80672 1.98137 6.75918 3.21448 6.75918 4.67857H7.05918C7.05918 3.35853 8.0033 2.25255 9.25117 2.04296L9.20148 1.7471ZM9.37633 1.89503V0.5H9.07633V1.89503H9.37633ZM9.22633 0.65H10.2263V0.35H9.22633V0.65ZM10.0763 0.5V1.91114H10.3763V0.5H10.0763ZM9.68274 6.35C8.79853 6.35 8.05918 5.61426 8.05918 4.67857H7.75918C7.75918 5.77452 8.62747 6.65 9.68274 6.65V6.35ZM11.3063 4.67857C11.3063 5.61426 10.5669 6.35 9.68274 6.35V6.65C10.738 6.65 11.6063 5.77452 11.6063 4.67857H11.3063ZM9.68274 3.00714C10.5669 3.00714 11.3063 3.74288 11.3063 4.67857H11.6063C11.6063 3.58262 10.738 2.70714 9.68274 2.70714V3.00714ZM8.05918 4.67857C8.05918 3.74288 8.79853 3.00714 9.68274 3.00714V2.70714C8.62747 2.70714 7.75918 3.58262 7.75918 4.67857H8.05918Z'
        fill='black'
      />
    </svg>
  )
}

export function SendIcon({ className }: Props) {
  return (
    <svg
      width='18'
      height='36'
      viewBox='0 0 18 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_642_5662)'>
        <path
          d='M12.1313 18.75H3V17.25H12.1313L7.93125 13.05L9 12L15 18L9 24L7.93125 22.95L12.1313 18.75Z'
          fill='#1D1B20'
        />
      </g>
      <defs>
        <clipPath id='clip0_642_5662'>
          <path
            d='M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9V27C18 31.9706 13.9706 36 9 36C4.02944 36 0 31.9706 0 27V9Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function GenerateLoadingIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 17C7.92031 17 6.87188 16.7891 5.88594 16.3719C4.93281 15.9687 4.07813 15.3906 3.34375 14.6562C2.60938 13.9219 2.03125 13.0672 1.62813 12.1141C1.21094 11.1281 1 10.0797 1 9C1 8.68906 1.25156 8.4375 1.5625 8.4375C1.87344 8.4375 2.125 8.68906 2.125 9C2.125 9.92813 2.30625 10.8281 2.66563 11.6766C3.0125 12.4953 3.50781 13.2313 4.13906 13.8625C4.77031 14.4938 5.50625 14.9906 6.325 15.3359C7.17188 15.6937 8.07188 15.875 9 15.875C9.92813 15.875 10.8281 15.6938 11.6766 15.3344C12.4953 14.9875 13.2313 14.4922 13.8625 13.8609C14.4938 13.2297 14.9906 12.4938 15.3359 11.675C15.6938 10.8281 15.875 9.92813 15.875 9C15.875 8.07187 15.6938 7.17188 15.3344 6.32344C14.9887 5.50665 14.4884 4.76439 13.8609 4.1375C13.2347 3.50925 12.4923 3.0088 11.675 2.66406C10.8281 2.30625 9.92813 2.125 9 2.125C8.68906 2.125 8.4375 1.87344 8.4375 1.5625C8.4375 1.25156 8.68906 1 9 1C10.0797 1 11.1281 1.21094 12.1141 1.62813C13.0672 2.03125 13.9219 2.60938 14.6563 3.34375C15.3906 4.07812 15.9672 4.93438 16.3703 5.88594C16.7875 6.87188 16.9984 7.92031 16.9984 9C16.9984 10.0797 16.7875 11.1281 16.3703 12.1141C15.9688 13.0672 15.3906 13.9219 14.6563 14.6562C13.9219 15.3906 13.0656 15.9672 12.1141 16.3703C11.1281 16.7891 10.0797 17 9 17V17Z'
        fill='url(#paint0_linear_824_9246)'
        stroke='url(#paint1_linear_824_9246)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_824_9246'
          x1='1'
          y1='9'
          x2='16.9984'
          y2='9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_824_9246'
          x1='1'
          y1='9'
          x2='16.9984'
          y2='9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function RightPanelCopyIcon({ className }: Props) {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M1.49805 2H13.498V5H11.998V3.5H2.99805V12.5H4.49805V14H1.49805V2ZM5.99805 6.5H16.498V17H5.99805V6.5ZM7.49805 8V15.5H14.998V8H7.49805Z'
        fill='#161513'
      />
    </svg>
  )
}

export function RightPanelUploadIcon({ className }: Props) {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M8.99805 1.99744L13.2825 6.34881L12.2136 7.40121L9.74805 4.89711V12.5H8.24805V4.89711L5.78247 7.40121L4.71362 6.34881L8.99805 1.99744ZM1.49805 11.75H2.99805V15.5H14.998V11.75H16.498V17H1.49805V11.75Z'
        fill='#161513'
      />
    </svg>
  )
}

export function CaretRightIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_329_82129)'>
        <path
          d='M4.64597 8.35375L9.64597 13.3538C9.69243 13.4002 9.74758 13.4371 9.80827 13.4622C9.86897 13.4873 9.93402 13.5003 9.99972 13.5003C10.0654 13.5003 10.1305 13.4873 10.1912 13.4622C10.2519 13.4371 10.307 13.4002 10.3535 13.3538C10.3999 13.3073 10.4368 13.2521 10.4619 13.1915C10.4871 13.1308 10.5 13.0657 10.5 13C10.5 12.9343 10.4871 12.8693 10.4619 12.8086C10.4368 12.7479 10.3999 12.6927 10.3535 12.6463L5.7066 8L10.3535 3.35375C10.4473 3.25993 10.5 3.13269 10.5 3C10.5 2.86732 10.4473 2.74007 10.3535 2.64625C10.2597 2.55243 10.1324 2.49973 9.99972 2.49973C9.86704 2.49973 9.73979 2.55243 9.64597 2.64625L4.64597 7.64625C4.59948 7.69269 4.5626 7.74783 4.53744 7.80853C4.51228 7.86923 4.49933 7.9343 4.49933 8C4.49933 8.06571 4.51228 8.13077 4.53744 8.19147C4.5626 8.25217 4.59948 8.30732 4.64597 8.35375Z'
          fill='black'
          fillOpacity='0.45'
        />
      </g>
      <defs>
        <clipPath id='clip0_329_82129'>
          <rect width='16' height='16' fill='white' transform='matrix(-1 0 0 1 16 0)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ConnectToRepositoryIcon({ className }: Props) {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M2.25 12C2.25 9.23858 4.48858 7 7.25 7H11.25V9H7.25C5.59315 9 4.25 10.3431 4.25 12C4.25 13.6569 5.59315 15 7.25 15H11.25V17H7.25C4.48858 17 2.25 14.7614 2.25 12Z'
        fill='url(#paint0_linear_651_71756)'
      />
      <path
        d='M22.25 12C22.25 14.7614 20.0114 17 17.25 17L13.25 17V15L17.25 15C18.9069 15 20.25 13.6569 20.25 12C20.25 10.3431 18.9069 9 17.25 9L13.25 9V7H17.25C20.0114 7 22.25 9.23858 22.25 12Z'
        fill='url(#paint1_linear_651_71756)'
      />
      <path d='M7.25 13H17.25V11H7.25V13Z' fill='url(#paint2_linear_651_71756)' />
      <defs>
        <linearGradient
          id='paint0_linear_651_71756'
          x1='2.25'
          y1='12'
          x2='22.25'
          y2='12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_651_71756'
          x1='2.25'
          y1='12'
          x2='22.25'
          y2='12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_651_71756'
          x1='2.25'
          y1='12'
          x2='22.25'
          y2='12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function UploadRepositoryIcon({ className }: Props) {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_651_71750)'>
        <path
          d='M23.25 12.7501V18.7501C23.25 19.1479 23.092 19.5295 22.8107 19.8108C22.5294 20.0921 22.1478 20.2501 21.75 20.2501H3.75C3.35218 20.2501 2.97064 20.0921 2.68934 19.8108C2.40804 19.5295 2.25 19.1479 2.25 18.7501V12.7501C2.25 12.3523 2.40804 11.9707 2.68934 11.6894C2.97064 11.4081 3.35218 11.2501 3.75 11.2501H8.25C8.44891 11.2501 8.63968 11.3291 8.78033 11.4698C8.92098 11.6104 9 11.8012 9 12.0001C9 12.199 8.92098 12.3898 8.78033 12.5304C8.63968 12.6711 8.44891 12.7501 8.25 12.7501H3.75V18.7501H21.75V12.7501H17.25C17.0511 12.7501 16.8603 12.6711 16.7197 12.5304C16.579 12.3898 16.5 12.199 16.5 12.0001C16.5 11.8012 16.579 11.6104 16.7197 11.4698C16.8603 11.3291 17.0511 11.2501 17.25 11.2501H21.75C22.1478 11.2501 22.5294 11.4081 22.8107 11.6894C23.092 11.9707 23.25 12.3523 23.25 12.7501ZM8.78063 7.28073L12 4.06041V12.0001C12 12.199 12.079 12.3898 12.2197 12.5304C12.3603 12.6711 12.5511 12.7501 12.75 12.7501C12.9489 12.7501 13.1397 12.6711 13.2803 12.5304C13.421 12.3898 13.5 12.199 13.5 12.0001V4.06041L16.7194 7.28073C16.8601 7.42146 17.051 7.50052 17.25 7.50052C17.449 7.50052 17.6399 7.42146 17.7806 7.28073C17.9214 7.14 18.0004 6.94912 18.0004 6.7501C18.0004 6.55108 17.9214 6.36021 17.7806 6.21948L13.2806 1.71948C13.211 1.64974 13.1283 1.59443 13.0372 1.55668C12.9462 1.51894 12.8486 1.49951 12.75 1.49951C12.6514 1.49951 12.5538 1.51894 12.4628 1.55668C12.3717 1.59443 12.289 1.64974 12.2194 1.71948L7.71937 6.21948C7.57864 6.36021 7.49958 6.55108 7.49958 6.7501C7.49958 6.94912 7.57864 7.14 7.71938 7.28073C7.86011 7.42146 8.05098 7.50052 8.25 7.50052C8.44902 7.50052 8.63989 7.42146 8.78063 7.28073ZM19.5 15.7501C19.5 15.5276 19.434 15.3101 19.3104 15.1251C19.1868 14.9401 19.0111 14.7959 18.8055 14.7107C18.6 14.6256 18.3738 14.6033 18.1555 14.6467C17.9373 14.6901 17.7368 14.7973 17.5795 14.9546C17.4222 15.1119 17.315 15.3124 17.2716 15.5306C17.2282 15.7489 17.2505 15.9751 17.3356 16.1806C17.4208 16.3862 17.565 16.5619 17.75 16.6855C17.935 16.8091 18.1525 16.8751 18.375 16.8751C18.6734 16.8751 18.9595 16.7566 19.1705 16.5456C19.3815 16.3346 19.5 16.0485 19.5 15.7501Z'
          fill='url(#paint0_linear_651_71750)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_651_71750'
          x1='2.25'
          y1='10.8748'
          x2='23.25'
          y2='10.8748'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <clipPath id='clip0_651_71750'>
          <rect width='24' height='24' fill='white' transform='translate(0.75)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function UploadButtonIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.25 2.86875L1.05 7.06875L0 6L6 0L12 6L10.95 7.06875L6.75 2.86875V12H5.25V2.86875Z'
        fill='#FCFCFC'
      />
    </svg>
  )
}

export function AddCommentIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 1.25C5.16797 1.25 1.25 5.16797 1.25 10C1.25 14.832 5.16797 18.75 10 18.75C14.832 18.75 18.75 14.832 18.75 10C18.75 5.16797 14.832 1.25 10 1.25ZM13.75 10.4688C13.75 10.5547 13.6797 10.625 13.5938 10.625H10.625V13.5938C10.625 13.6797 10.5547 13.75 10.4688 13.75H9.53125C9.44531 13.75 9.375 13.6797 9.375 13.5938V10.625H6.40625C6.32031 10.625 6.25 10.5547 6.25 10.4688V9.53125C6.25 9.44531 6.32031 9.375 6.40625 9.375H9.375V6.40625C9.375 6.32031 9.44531 6.25 9.53125 6.25H10.4688C10.5547 6.25 10.625 6.32031 10.625 6.40625V9.375H13.5938C13.6797 9.375 13.75 9.44531 13.75 9.53125V10.4688Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function EditCommentIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.6464 1.67383L18.3389 5.36298L5.35673 18.3336H1.66504V14.6437L14.6464 1.67383ZM12.8932 5.7815L14.2275 7.11468L15.9808 5.36298L14.6464 4.0298L12.8932 5.7815ZM13.0485 8.29266L11.7141 6.95949L3.33171 15.3345V16.6669H4.6668L13.0485 8.29266Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function MessageIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.1'
        d='M15.1436 4.86037C14.4783 4.19281 13.6887 3.66199 12.8194 3.29787C11.9278 2.92326 10.9701 2.73132 10.003 2.73342H9.96979C8.02252 2.74123 6.20026 3.50295 4.83698 4.8799C3.47174 6.25685 2.7276 8.08498 2.73541 10.0322C2.74127 11.21 3.03424 12.3799 3.58502 13.4131L3.67291 13.5772V16.3272H6.42291L6.58698 16.4151C7.62018 16.9658 8.7901 17.2588 9.96783 17.2647H10.001C11.9346 17.2647 13.751 16.5186 15.1202 15.1631C16.4952 13.7998 17.2589 11.9776 17.2706 10.0322C17.2745 9.04396 17.085 8.08693 16.7061 7.18459C16.3418 6.31541 15.811 5.52586 15.1436 4.86037ZM6.09479 10.9365C5.84946 10.9315 5.61587 10.8306 5.44414 10.6553C5.27241 10.48 5.17623 10.2444 5.17623 9.99904C5.17623 9.75366 5.27241 9.51806 5.44414 9.34279C5.61587 9.16752 5.84946 9.06655 6.09479 9.06154C6.34011 9.06655 6.5737 9.16752 6.74543 9.34279C6.91716 9.51806 7.01334 9.75366 7.01334 9.99904C7.01334 10.2444 6.91716 10.48 6.74543 10.6553C6.5737 10.8306 6.34011 10.9315 6.09479 10.9365ZM10.001 10.9365C9.75571 10.9315 9.52212 10.8306 9.35039 10.6553C9.17866 10.48 9.08248 10.2444 9.08248 9.99904C9.08248 9.75366 9.17866 9.51806 9.35039 9.34279C9.52212 9.16752 9.75571 9.06655 10.001 9.06154C10.2464 9.06655 10.48 9.16752 10.6517 9.34279C10.8234 9.51806 10.9196 9.75366 10.9196 9.99904C10.9196 10.2444 10.8234 10.48 10.6517 10.6553C10.48 10.8306 10.2464 10.9315 10.001 10.9365ZM13.9073 10.9365C13.662 10.9315 13.4284 10.8306 13.2566 10.6553C13.0849 10.48 12.9887 10.2444 12.9887 9.99904C12.9887 9.75366 13.0849 9.51806 13.2566 9.34279C13.4284 9.16752 13.662 9.06655 13.9073 9.06154C14.1526 9.06655 14.3862 9.16752 14.5579 9.34279C14.7297 9.51806 14.8258 9.75366 14.8258 9.99904C14.8258 10.2444 14.7297 10.48 14.5579 10.6553C14.3862 10.8306 14.1526 10.9315 13.9073 10.9365Z'
        fill='black'
        fillOpacity='0.88'
      />
      <path
        d='M12.9688 10C12.9688 10.2486 13.0675 10.4871 13.2433 10.6629C13.4192 10.8387 13.6576 10.9375 13.9062 10.9375C14.1549 10.9375 14.3933 10.8387 14.5692 10.6629C14.745 10.4871 14.8438 10.2486 14.8438 10C14.8438 9.75136 14.745 9.5129 14.5692 9.33709C14.3933 9.16127 14.1549 9.0625 13.9062 9.0625C13.6576 9.0625 13.4192 9.16127 13.2433 9.33709C13.0675 9.5129 12.9688 9.75136 12.9688 10ZM5.15625 10C5.15625 10.2486 5.25502 10.4871 5.43084 10.6629C5.60665 10.8387 5.84511 10.9375 6.09375 10.9375C6.34239 10.9375 6.58085 10.8387 6.75666 10.6629C6.93248 10.4871 7.03125 10.2486 7.03125 10C7.03125 9.75136 6.93248 9.5129 6.75666 9.33709C6.58085 9.16127 6.34239 9.0625 6.09375 9.0625C5.84511 9.0625 5.60665 9.16127 5.43084 9.33709C5.25502 9.5129 5.15625 9.75136 5.15625 10Z'
        fill='#2E1F36'
      />
      <path
        d='M18.0704 6.60938C17.629 5.56055 16.9962 4.61914 16.1896 3.81055C15.3886 3.00663 14.4377 2.36762 13.3907 1.92969C12.3165 1.47852 11.1759 1.25 10.0001 1.25H9.96105C8.77745 1.25586 7.63097 1.49023 6.55285 1.95117C5.51487 2.3936 4.57289 3.03374 3.77941 3.83594C2.98058 4.64258 2.35363 5.58008 1.92003 6.625C1.47081 7.70703 1.24425 8.85742 1.25011 10.041C1.25674 11.3974 1.57763 12.7338 2.18761 13.9453V16.9141C2.18761 17.1523 2.28227 17.3809 2.45076 17.5494C2.61925 17.7178 2.84777 17.8125 3.08605 17.8125H6.05675C7.26826 18.4225 8.60466 18.7434 9.96105 18.75H10.0021C11.172 18.75 12.3068 18.5234 13.3751 18.0801C14.4168 17.6474 15.3641 17.0158 16.1642 16.2207C16.9708 15.4219 17.6056 14.4883 18.0489 13.4473C18.5099 12.3691 18.7443 11.2227 18.7501 10.0391C18.756 8.84961 18.5255 7.69531 18.0704 6.60938ZM15.1193 15.1641C13.7501 16.5195 11.9337 17.2656 10.0001 17.2656H9.96691C8.78917 17.2598 7.61925 16.9668 6.58605 16.416L6.42199 16.3281H3.67199V13.5781L3.5841 13.4141C3.03331 12.3809 2.74035 11.2109 2.73449 10.0332C2.72667 8.08594 3.47081 6.25781 4.83605 4.88086C6.19933 3.50391 8.0216 2.74219 9.96886 2.73438H10.0021C10.9786 2.73438 11.9259 2.92383 12.8185 3.29883C13.6896 3.66406 14.4708 4.18945 15.1427 4.86133C15.8126 5.53125 16.34 6.31445 16.7052 7.18555C17.0841 8.08789 17.2735 9.04492 17.2696 10.0332C17.2579 11.9785 16.4943 13.8008 15.1193 15.1641Z'
        fill='#2E1F36'
      />
      <path
        d='M9.0625 10C9.0625 10.2486 9.16127 10.4871 9.33709 10.6629C9.5129 10.8387 9.75136 10.9375 10 10.9375C10.2486 10.9375 10.4871 10.8387 10.6629 10.6629C10.8387 10.4871 10.9375 10.2486 10.9375 10C10.9375 9.75136 10.8387 9.5129 10.6629 9.33709C10.4871 9.16127 10.2486 9.0625 10 9.0625C9.75136 9.0625 9.5129 9.16127 9.33709 9.33709C9.16127 9.5129 9.0625 9.75136 9.0625 10Z'
        fill='#2E1F36'
      />
    </svg>
  )
}

export function ProgressBarIcon({ className, style }: Props) {
  return (
    <svg
      width='168'
      height='12'
      viewBox='0 0 168 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      style={style}
    >
      <path
        d='M46.916 6L36.916 6L16.916 6L6.91602 6'
        stroke='url(#paint0_linear_950_15537)'
        strokeWidth='4'
        strokeLinecap='round'
      />
      <path
        d='M46.916 6H75.416H132.416H160.916'
        stroke='url(#paint1_linear_950_15537)'
        strokeWidth='4'
        strokeLinecap='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_950_15537'
          x1='46.916'
          y1='5.5'
          x2='6.91602'
          y2='5.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_950_15537'
          x1='46.916'
          y1='6.5'
          x2='160.916'
          y2='6.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function TimeLineDotIcon({ className }: Props) {
  return (
    <svg width='12' height='44' viewBox='0 0 12 44' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10 10C10 12.2091 8.20914 14 6 14C3.79086 14 2 12.2091 2 10C2 7.79086 3.79086 6 6 6C8.20914 6 10 7.79086 10 10ZM2.8 10C2.8 11.7673 4.23269 13.2 6 13.2C7.76731 13.2 9.2 11.7673 9.2 10C9.2 8.23269 7.76731 6.8 6 6.8C4.23269 6.8 2.8 8.23269 2.8 10Z'
        fill='#4A4458'
        className={className}
      />
      <line x1='6.5' y1='14' x2='6.5' y2='44' stroke='#D6D6D6' />
      <line x1='6.5' y1='2.18558e-08' x2='6.5' y2='6' stroke='#D6D6D6' />
      <circle cx='6.00033' cy='10' r='2.33333' fill='#4A4458' />
    </svg>
  )
}

export function DropDownIcon({ className }: Props) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_329_79170)'>
        <path
          d='M10.0155 4.76534L6.26552 8.51534C6.23069 8.5502 6.18934 8.57786 6.14381 8.59674C6.09829 8.61561 6.04949 8.62532 6.00021 8.62532C5.95093 8.62532 5.90213 8.61561 5.85661 8.59674C5.81108 8.57786 5.76972 8.5502 5.7349 8.51534L1.9849 4.76534C1.91453 4.69497 1.875 4.59954 1.875 4.50003C1.875 4.40051 1.91453 4.30508 1.9849 4.23471C2.05526 4.16435 2.1507 4.12482 2.25021 4.12482C2.34972 4.12482 2.44516 4.16435 2.51552 4.23471L6.00021 7.71987L9.4849 4.23471C9.51974 4.19987 9.5611 4.17223 9.60662 4.15338C9.65214 4.13452 9.70094 4.12482 9.75021 4.12482C9.79948 4.12482 9.84827 4.13452 9.8938 4.15338C9.93932 4.17223 9.98068 4.19987 10.0155 4.23471C10.0504 4.26955 10.078 4.31092 10.0969 4.35644C10.1157 4.40196 10.1254 4.45075 10.1254 4.50003C10.1254 4.5493 10.1157 4.59809 10.0969 4.64361C10.078 4.68913 10.0504 4.7305 10.0155 4.76534Z'
          fill='#2E1F36'
        />
      </g>
      <defs>
        <clipPath id='clip0_329_79170'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function TimelineSpanIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_1018_2913)'>
        <path
          d='M8 16C6.92031 16 5.87188 15.7891 4.88594 15.3719C3.93281 14.9687 3.07813 14.3906 2.34375 13.6562C1.60938 12.9219 1.03125 12.0672 0.628125 11.1141C0.210938 10.1281 0 9.07969 0 8C0 7.68906 0.251563 7.4375 0.5625 7.4375C0.873438 7.4375 1.125 7.68906 1.125 8C1.125 8.92813 1.30625 9.82812 1.66563 10.6766C2.0125 11.4953 2.50781 12.2313 3.13906 12.8625C3.77031 13.4938 4.50625 13.9906 5.325 14.3359C6.17188 14.6937 7.07188 14.875 8 14.875C8.92813 14.875 9.82813 14.6938 10.6766 14.3344C11.4953 13.9875 12.2313 13.4922 12.8625 12.8609C13.4938 12.2297 13.9906 11.4938 14.3359 10.675C14.6938 9.82813 14.875 8.92813 14.875 8C14.875 7.07187 14.6938 6.17188 14.3344 5.32344C13.9887 4.50665 13.4884 3.76439 12.8609 3.1375C12.2347 2.50925 11.4923 2.0088 10.675 1.66406C9.82813 1.30625 8.92813 1.125 8 1.125C7.68906 1.125 7.4375 0.873437 7.4375 0.5625C7.4375 0.251563 7.68906 0 8 0C9.07969 0 10.1281 0.210938 11.1141 0.628125C12.0672 1.03125 12.9219 1.60938 13.6563 2.34375C14.3906 3.07812 14.9672 3.93438 15.3703 4.88594C15.7875 5.87188 15.9984 6.92031 15.9984 8C15.9984 9.07969 15.7875 10.1281 15.3703 11.1141C14.9688 12.0672 14.3906 12.9219 13.6563 13.6562C12.9219 14.3906 12.0656 14.9672 11.1141 15.3703C10.1281 15.7891 9.07969 16 8 16V16Z'
          fill='url(#paint0_linear_1018_2913)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1018_2913'
          x1='0'
          y1='8'
          x2='15.9984'
          y2='8'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <clipPath id='clip0_1018_2913'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ResultTabsCloseIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1365_25629)'>
        <path
          d='M11.3538 8.85403L6.35378 13.854C6.30733 13.9005 6.25218 13.9373 6.19148 13.9625C6.13079 13.9876 6.06573 14.0006 6.00003 14.0006C5.93434 14.0006 5.86928 13.9876 5.80859 13.9625C5.74789 13.9373 5.69274 13.9005 5.64628 13.854C5.59983 13.8076 5.56298 13.7524 5.53784 13.6917C5.5127 13.631 5.49976 13.566 5.49976 13.5003C5.49976 13.4346 5.5127 13.3695 5.53784 13.3088C5.56298 13.2481 5.59983 13.193 5.64628 13.1465L10.2932 8.50028L5.64628 3.85403C5.55246 3.76021 5.49976 3.63296 5.49976 3.50028C5.49976 3.3676 5.55246 3.24035 5.64628 3.14653C5.7401 3.05271 5.86735 3 6.00003 3C6.13272 3 6.25996 3.05271 6.35378 3.14653L11.3538 8.14653C11.4003 8.19296 11.4372 8.24811 11.4623 8.30881C11.4875 8.36951 11.5004 8.43457 11.5004 8.50028C11.5004 8.56599 11.4875 8.63105 11.4623 8.69175C11.4372 8.75245 11.4003 8.80759 11.3538 8.85403Z'
          fill='black'
          fillOpacity='0.45'
        />
      </g>
      <defs>
        <clipPath id='clip0_1365_25629'>
          <rect width='16' height='16' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ResultTabsOpenIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1365_25452)'>
        <path
          d='M13.3538 6.85403L8.35378 11.854C8.30735 11.9005 8.2522 11.9374 8.1915 11.9626C8.13081 11.9877 8.06574 12.0007 8.00003 12.0007C7.93433 12.0007 7.86926 11.9877 7.80856 11.9626C7.74786 11.9374 7.69272 11.9005 7.64628 11.854L2.64628 6.85403C2.55246 6.76021 2.49976 6.63296 2.49976 6.50028C2.49976 6.3676 2.55246 6.24035 2.64628 6.14653C2.7401 6.05271 2.86735 6 3.00003 6C3.13272 6 3.25996 6.05271 3.35378 6.14653L8.00003 10.7934L12.6463 6.14653C12.6927 6.10007 12.7479 6.06322 12.8086 6.03808C12.8693 6.01294 12.9343 6 13 6C13.0657 6 13.1308 6.01294 13.1915 6.03808C13.2522 6.06322 13.3073 6.10007 13.3538 6.14653C13.4002 6.19298 13.4371 6.24813 13.4622 6.30883C13.4874 6.36953 13.5003 6.43458 13.5003 6.50028C13.5003 6.56598 13.4874 6.63103 13.4622 6.69173C13.4371 6.75242 13.4002 6.80757 13.3538 6.85403Z'
          fill='black'
          fillOpacity='0.45'
        />
      </g>
      <defs>
        <clipPath id='clip0_1365_25452'>
          <rect width='16' height='16' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ResultTabsCheckIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='10'
      height='11'
      viewBox='0 0 10 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.90604 2.35547H8.22342C8.12772 2.35547 8.0369 2.39941 7.97831 2.47461L3.95194 7.57519L2.02128 5.12891C1.99207 5.09182 1.95484 5.06184 1.91239 5.04121C1.86994 5.02057 1.82336 5.00982 1.77616 5.00977H1.09354C1.02811 5.00977 0.991979 5.08496 1.03202 5.13574L3.70682 8.52441C3.83182 8.68262 4.07206 8.68262 4.19803 8.52441L8.96757 2.48047C9.00761 2.43066 8.97147 2.35547 8.90604 2.35547Z'
        fill='#F9F1F8'
      />
    </svg>
  )
}

export function AgenticUIFileUploadIcon({ className }: Props) {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_1643_21893)'>
        <path
          d='M22.6667 12.75V18.75C22.6667 19.1478 22.5086 19.5293 22.2273 19.8106C21.946 20.0919 21.5645 20.25 21.1667 20.25H3.16666C2.76883 20.25 2.3873 20.0919 2.106 19.8106C1.82469 19.5293 1.66666 19.1478 1.66666 18.75V12.75C1.66666 12.3522 1.82469 11.9706 2.106 11.6893C2.3873 11.408 2.76883 11.25 3.16666 11.25H7.66666C7.86557 11.25 8.05633 11.329 8.19699 11.4696C8.33764 11.6103 8.41666 11.8011 8.41666 12C8.41666 12.1989 8.33764 12.3897 8.19699 12.5303C8.05633 12.671 7.86557 12.75 7.66666 12.75H3.16666V18.75H21.1667V12.75H16.6667C16.4677 12.75 16.277 12.671 16.1363 12.5303C15.9957 12.3897 15.9167 12.1989 15.9167 12C15.9167 11.8011 15.9957 11.6103 16.1363 11.4696C16.277 11.329 16.4677 11.25 16.6667 11.25H21.1667C21.5645 11.25 21.946 11.408 22.2273 11.6893C22.5086 11.9706 22.6667 12.3522 22.6667 12.75ZM8.19728 7.28061L11.4167 4.06029V12C11.4167 12.1989 11.4957 12.3897 11.6363 12.5303C11.777 12.671 11.9677 12.75 12.1667 12.75C12.3656 12.75 12.5563 12.671 12.697 12.5303C12.8376 12.3897 12.9167 12.1989 12.9167 12V4.06029L16.136 7.28061C16.2768 7.42134 16.4676 7.5004 16.6667 7.5004C16.8657 7.5004 17.0566 7.42134 17.1973 7.28061C17.338 7.13987 17.4171 6.949 17.4171 6.74998C17.4171 6.55096 17.338 6.36008 17.1973 6.21935L12.6973 1.71935C12.6276 1.64962 12.5449 1.5943 12.4539 1.55656C12.3628 1.51882 12.2652 1.49939 12.1667 1.49939C12.0681 1.49939 11.9705 1.51882 11.8795 1.55656C11.7884 1.5943 11.7057 1.64962 11.636 1.71935L7.13603 6.21935C6.9953 6.36008 6.91624 6.55096 6.91624 6.74998C6.91624 6.949 6.9953 7.13987 7.13603 7.2806C7.27676 7.42133 7.46763 7.5004 7.66666 7.5004C7.86568 7.5004 8.05655 7.42134 8.19728 7.28061ZM18.9167 15.75C18.9167 15.5275 18.8507 15.31 18.7271 15.125C18.6034 14.94 18.4277 14.7958 18.2222 14.7106C18.0166 14.6255 17.7904 14.6032 17.5722 14.6466C17.354 14.69 17.1535 14.7972 16.9962 14.9545C16.8388 15.1118 16.7317 15.3123 16.6883 15.5305C16.6449 15.7487 16.6671 15.9749 16.7523 16.1805C16.8374 16.3861 16.9816 16.5618 17.1666 16.6854C17.3516 16.809 17.5692 16.875 17.7917 16.875C18.09 16.875 18.3762 16.7565 18.5872 16.5455C18.7981 16.3345 18.9167 16.0483 18.9167 15.75Z'
          fill='url(#paint0_linear_1643_21893)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1643_21893'
          x1='1.66666'
          y1='10.8747'
          x2='22.6667'
          y2='10.8747'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <clipPath id='clip0_1643_21893'>
          <rect width='24' height='24' fill='white' transform='translate(0.166656)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CheckCircleOutlinedIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.2864 6.20508H11.462C11.2827 6.20508 11.1122 6.29121 11.0067 6.43887L8.24346 10.2709L6.99189 8.53418C6.88642 8.38828 6.71767 8.30039 6.53661 8.30039H5.7122C5.59794 8.30039 5.53114 8.43047 5.59794 8.52363L7.78818 11.5611C7.83992 11.6334 7.90813 11.6922 7.98715 11.7328C8.06618 11.7734 8.15374 11.7946 8.24258 11.7946C8.33142 11.7946 8.41898 11.7734 8.498 11.7328C8.57702 11.6922 8.64523 11.6334 8.69697 11.5611L12.3989 6.42832C12.4675 6.33516 12.4007 6.20508 12.2864 6.20508Z'
        fill='black'
        fillOpacity='0.45'
      />
      <path
        d='M9 1.125C4.65117 1.125 1.125 4.65117 1.125 9C1.125 13.3488 4.65117 16.875 9 16.875C13.3488 16.875 16.875 13.3488 16.875 9C16.875 4.65117 13.3488 1.125 9 1.125ZM9 15.5391C5.38945 15.5391 2.46094 12.6105 2.46094 9C2.46094 5.38945 5.38945 2.46094 9 2.46094C12.6105 2.46094 15.5391 5.38945 15.5391 9C15.5391 12.6105 12.6105 15.5391 9 15.5391Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function CheckCircleTwoToneIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 1.125C4.65117 1.125 1.125 4.65117 1.125 9C1.125 13.3488 4.65117 16.875 9 16.875C13.3488 16.875 16.875 13.3488 16.875 9C16.875 4.65117 13.3488 1.125 9 1.125ZM9 15.5391C5.38945 15.5391 2.46094 12.6105 2.46094 9C2.46094 5.38945 5.38945 2.46094 9 2.46094C12.6105 2.46094 15.5391 5.38945 15.5391 9C15.5391 12.6105 12.6105 15.5391 9 15.5391Z'
        fill='url(#paint0_linear_1569_396)'
      />
      <path
        opacity='0.1'
        d='M9 2.46094C5.38945 2.46094 2.46094 5.38945 2.46094 9C2.46094 12.6105 5.38945 15.5391 9 15.5391C12.6105 15.5391 15.5391 12.6105 15.5391 9C15.5391 5.38945 12.6105 2.46094 9 2.46094ZM12.3996 6.42832L8.69766 11.5611C8.64591 11.6333 8.57771 11.6922 8.49868 11.7328C8.41966 11.7734 8.3321 11.7946 8.24326 11.7946C8.15442 11.7946 8.06686 11.7734 7.98784 11.7328C7.90882 11.6922 7.84061 11.6333 7.78887 11.5611L5.59863 8.52363C5.53184 8.43047 5.59863 8.30039 5.71289 8.30039H6.5373C6.71836 8.30039 6.88711 8.38828 6.99258 8.53418L8.24414 10.2709L11.0074 6.43887C11.1129 6.29121 11.2834 6.20508 11.4627 6.20508H12.2871C12.4014 6.20508 12.4682 6.33516 12.3996 6.42832V6.42832Z'
        fill='url(#paint1_linear_1569_396)'
      />
      <path
        d='M12.2864 6.20508H11.462C11.2827 6.20508 11.1122 6.29121 11.0067 6.43887L8.2434 10.2709L6.99183 8.53418C6.88636 8.38828 6.71761 8.30039 6.53655 8.30039H5.71214C5.59788 8.30039 5.53108 8.43047 5.59788 8.52363L7.78812 11.5611C7.83986 11.6334 7.90807 11.6922 7.98709 11.7328C8.06612 11.7734 8.15368 11.7946 8.24252 11.7946C8.33136 11.7946 8.41892 11.7734 8.49794 11.7328C8.57696 11.6922 8.64517 11.6334 8.69691 11.5611L12.3989 6.42832C12.4674 6.33516 12.4006 6.20508 12.2864 6.20508V6.20508Z'
        fill='url(#paint2_linear_1569_396)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1569_396'
          x1='1.125'
          y1='9'
          x2='16.875'
          y2='9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1569_396'
          x1='2.46094'
          y1='9'
          x2='15.5391'
          y2='9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1569_396'
          x1='5.57129'
          y1='8.99982'
          x2='12.4266'
          y2='8.99982'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function CheckCircleTwoTonePremiumIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 1.125C4.65117 1.125 1.125 4.65117 1.125 9C1.125 13.3488 4.65117 16.875 9 16.875C13.3488 16.875 16.875 13.3488 16.875 9C16.875 4.65117 13.3488 1.125 9 1.125ZM9 15.5391C5.38945 15.5391 2.46094 12.6105 2.46094 9C2.46094 5.38945 5.38945 2.46094 9 2.46094C12.6105 2.46094 15.5391 5.38945 15.5391 9C15.5391 12.6105 12.6105 15.5391 9 15.5391Z'
        fill='#AC99FF'
      />
      <path
        opacity='0.1'
        d='M9 2.46094C5.38945 2.46094 2.46094 5.38945 2.46094 9C2.46094 12.6105 5.38945 15.5391 9 15.5391C12.6105 15.5391 15.5391 12.6105 15.5391 9C15.5391 5.38945 12.6105 2.46094 9 2.46094ZM12.3996 6.42832L8.69766 11.5611C8.64591 11.6333 8.57771 11.6922 8.49868 11.7328C8.41966 11.7734 8.3321 11.7946 8.24326 11.7946C8.15442 11.7946 8.06686 11.7734 7.98784 11.7328C7.90882 11.6922 7.84061 11.6333 7.78887 11.5611L5.59863 8.52363C5.53184 8.43047 5.59863 8.30039 5.71289 8.30039H6.5373C6.71836 8.30039 6.88711 8.38828 6.99258 8.53418L8.24414 10.2709L11.0074 6.43887C11.1129 6.29121 11.2834 6.20508 11.4627 6.20508H12.2871C12.4014 6.20508 12.4682 6.33516 12.3996 6.42832V6.42832Z'
        fill='#AC99FF'
      />
      <path
        d='M12.2864 6.20508H11.462C11.2827 6.20508 11.1122 6.29121 11.0067 6.43887L8.2434 10.2709L6.99183 8.53418C6.88636 8.38828 6.71761 8.30039 6.53655 8.30039H5.71214C5.59788 8.30039 5.53108 8.43047 5.59788 8.52363L7.78812 11.5611C7.83986 11.6334 7.90807 11.6922 7.98709 11.7328C8.06612 11.7734 8.15368 11.7946 8.24252 11.7946C8.33136 11.7946 8.41892 11.7734 8.49794 11.7328C8.57696 11.6922 8.64517 11.6334 8.69691 11.5611L12.3989 6.42832C12.4674 6.33516 12.4006 6.20508 12.2864 6.20508V6.20508Z'
        fill='#AC99FF'
      />
    </svg>
  )
}

export function CodeEditorRemoveIcon({ className }: Props) {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M8 1.5C4.13438 1.5 1 4.63438 1 8.5C1 12.3656 4.13438 15.5 8 15.5C11.8656 15.5 15 12.3656 15 8.5C15 4.63438 11.8656 1.5 8 1.5ZM11 8.875C11 8.94375 10.9438 9 10.875 9H5.125C5.05625 9 5 8.94375 5 8.875V8.125C5 8.05625 5.05625 8 5.125 8H10.875C10.9438 8 11 8.05625 11 8.125V8.875Z'
        fill='#EA462D'
      />
    </svg>
  )
}

export function CodeEditorAddIcon({ className }: Props) {
  return (
    <svg
      width='96'
      height='17'
      viewBox='0 0 96 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M8 1.5C4.13438 1.5 1 4.63438 1 8.5C1 12.3656 4.13438 15.5 8 15.5C11.8656 15.5 15 12.3656 15 8.5C15 4.63438 11.8656 1.5 8 1.5ZM11 8.875C11 8.94375 10.9438 9 10.875 9H8.5V11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V9H5.125C5.05625 9 5 8.94375 5 8.875V8.125C5 8.05625 5.05625 8 5.125 8H7.5V5.625C7.5 5.55625 7.55625 5.5 7.625 5.5H8.375C8.44375 5.5 8.5 5.55625 8.5 5.625V8H10.875C10.9438 8 11 8.05625 11 8.125V8.875Z'
        fill='#36A764'
      />
      <path
        d='M24.452 12.5V10.796H20.18V9.524L24.2 3.98H26.012V9.44H27.032V10.796H26.012V12.5H24.452ZM21.884 9.44H24.452V6.008L21.884 9.44ZM33.0242 12.644C32.3522 12.644 31.8122 12.492 31.4042 12.188C30.9962 11.876 30.7922 11.444 30.7922 10.892C30.7922 10.34 30.9642 9.908 31.3082 9.596C31.6522 9.284 32.1762 9.06 32.8802 8.924L35.0042 8.504C35.0042 8.048 34.9002 7.708 34.6922 7.484C34.4842 7.252 34.1762 7.136 33.7682 7.136C33.4002 7.136 33.1082 7.224 32.8922 7.4C32.6842 7.568 32.5402 7.812 32.4602 8.132L30.9002 8.06C31.0282 7.38 31.3402 6.86 31.8362 6.5C32.3322 6.132 32.9762 5.948 33.7682 5.948C34.6802 5.948 35.3682 6.18 35.8322 6.644C36.3042 7.1 36.5402 7.756 36.5402 8.612V10.94C36.5402 11.108 36.5682 11.224 36.6242 11.288C36.6882 11.352 36.7802 11.384 36.9002 11.384H37.1042V12.5C37.0562 12.516 36.9762 12.528 36.8642 12.536C36.7602 12.544 36.6522 12.548 36.5402 12.548C36.2762 12.548 36.0402 12.508 35.8322 12.428C35.6242 12.34 35.4642 12.192 35.3522 11.984C35.2402 11.768 35.1842 11.476 35.1842 11.108L35.3162 11.204C35.2522 11.484 35.1122 11.736 34.8962 11.96C34.6882 12.176 34.4242 12.344 34.1042 12.464C33.7842 12.584 33.4242 12.644 33.0242 12.644ZM33.3362 11.528C33.6802 11.528 33.9762 11.46 34.2242 11.324C34.4722 11.188 34.6642 11 34.8002 10.76C34.9362 10.52 35.0042 10.236 35.0042 9.908V9.548L33.3482 9.884C33.0042 9.956 32.7562 10.064 32.6042 10.208C32.4602 10.344 32.3882 10.524 32.3882 10.748C32.3882 10.996 32.4682 11.188 32.6282 11.324C32.7962 11.46 33.0322 11.528 33.3362 11.528ZM40.3114 12.644C39.7674 12.644 39.2954 12.508 38.8954 12.236C38.5034 11.964 38.1994 11.576 37.9834 11.072C37.7674 10.568 37.6594 9.976 37.6594 9.296C37.6594 8.616 37.7674 8.024 37.9834 7.52C38.1994 7.016 38.5074 6.628 38.9074 6.356C39.3074 6.084 39.7754 5.948 40.3114 5.948C40.7594 5.948 41.1514 6.04 41.4874 6.224C41.8314 6.408 42.0914 6.668 42.2674 7.004V3.98H43.8034V12.5H42.3394L42.3034 11.552C42.1274 11.896 41.8634 12.164 41.5114 12.356C41.1594 12.548 40.7594 12.644 40.3114 12.644ZM40.7794 11.396C41.0994 11.396 41.3674 11.316 41.5834 11.156C41.8074 10.996 41.9754 10.76 42.0874 10.448C42.2074 10.128 42.2674 9.744 42.2674 9.296C42.2674 8.84 42.2074 8.456 42.0874 8.144C41.9754 7.832 41.8074 7.596 41.5834 7.436C41.3674 7.276 41.0994 7.196 40.7794 7.196C40.3154 7.196 39.9434 7.384 39.6634 7.76C39.3914 8.128 39.2554 8.64 39.2554 9.296C39.2554 9.936 39.3914 10.448 39.6634 10.832C39.9434 11.208 40.3154 11.396 40.7794 11.396ZM47.6473 12.644C47.1033 12.644 46.6313 12.508 46.2313 12.236C45.8393 11.964 45.5353 11.576 45.3193 11.072C45.1033 10.568 44.9953 9.976 44.9953 9.296C44.9953 8.616 45.1033 8.024 45.3193 7.52C45.5353 7.016 45.8433 6.628 46.2433 6.356C46.6433 6.084 47.1113 5.948 47.6473 5.948C48.0953 5.948 48.4873 6.04 48.8233 6.224C49.1673 6.408 49.4273 6.668 49.6033 7.004V3.98H51.1393V12.5H49.6753L49.6393 11.552C49.4633 11.896 49.1993 12.164 48.8473 12.356C48.4953 12.548 48.0953 12.644 47.6473 12.644ZM48.1153 11.396C48.4353 11.396 48.7033 11.316 48.9193 11.156C49.1433 10.996 49.3113 10.76 49.4233 10.448C49.5433 10.128 49.6033 9.744 49.6033 9.296C49.6033 8.84 49.5433 8.456 49.4233 8.144C49.3113 7.832 49.1433 7.596 48.9193 7.436C48.7033 7.276 48.4353 7.196 48.1153 7.196C47.6513 7.196 47.2793 7.384 46.9993 7.76C46.7273 8.128 46.5913 8.64 46.5913 9.296C46.5913 9.936 46.7273 10.448 46.9993 10.832C47.2793 11.208 47.6513 11.396 48.1153 11.396ZM52.633 12.5V6.092H54.169V12.5H52.633ZM52.609 5.24V3.872H54.205V5.24H52.609ZM58.0252 12.5C57.3852 12.5 56.9132 12.352 56.6092 12.056C56.3132 11.76 56.1652 11.296 56.1652 10.664V4.592H57.7012V10.52C57.7012 10.816 57.7652 11.024 57.8932 11.144C58.0212 11.256 58.2212 11.312 58.4932 11.312H59.3932V12.5H58.0252ZM55.1572 7.28V6.092H59.3932V7.28H55.1572ZM60.5197 12.5V6.092H62.0557V12.5H60.5197ZM60.4957 5.24V3.872H62.0917V5.24H60.4957ZM66.4092 12.644C65.7772 12.644 65.2212 12.508 64.7412 12.236C64.2692 11.956 63.9012 11.564 63.6372 11.06C63.3812 10.556 63.2532 9.968 63.2532 9.296C63.2532 8.616 63.3812 8.028 63.6372 7.532C63.9012 7.028 64.2692 6.64 64.7412 6.368C65.2212 6.088 65.7772 5.948 66.4092 5.948C67.0412 5.948 67.5932 6.088 68.0652 6.368C68.5372 6.64 68.9012 7.028 69.1572 7.532C69.4212 8.028 69.5532 8.616 69.5532 9.296C69.5532 9.968 69.4212 10.556 69.1572 11.06C68.9012 11.564 68.5372 11.956 68.0652 12.236C67.5932 12.508 67.0412 12.644 66.4092 12.644ZM66.4092 11.396C66.9052 11.396 67.2852 11.212 67.5492 10.844C67.8212 10.476 67.9572 9.96 67.9572 9.296C67.9572 8.64 67.8212 8.128 67.5492 7.76C67.2852 7.384 66.9052 7.196 66.4092 7.196C65.9132 7.196 65.5292 7.384 65.2572 7.76C64.9852 8.128 64.8492 8.64 64.8492 9.296C64.8492 9.96 64.9852 10.476 65.2572 10.844C65.5292 11.212 65.9132 11.396 66.4092 11.396ZM70.7384 12.5V6.092H72.1304L72.1904 7.892L72.0104 7.82C72.0744 7.372 72.2064 7.012 72.4064 6.74C72.6064 6.468 72.8504 6.268 73.1384 6.14C73.4264 6.012 73.7424 5.948 74.0864 5.948C74.5584 5.948 74.9544 6.052 75.2744 6.26C75.6024 6.468 75.8504 6.756 76.0184 7.124C76.1864 7.484 76.2704 7.904 76.2704 8.384V12.5H74.7344V8.876C74.7344 8.516 74.6984 8.212 74.6264 7.964C74.5544 7.716 74.4344 7.528 74.2664 7.4C74.1064 7.264 73.8904 7.196 73.6184 7.196C73.2104 7.196 72.8824 7.34 72.6344 7.628C72.3944 7.916 72.2744 8.332 72.2744 8.876V12.5H70.7384ZM80.3971 12.644C79.7651 12.644 79.2331 12.552 78.8011 12.368C78.3771 12.184 78.0491 11.928 77.8171 11.6C77.5851 11.272 77.4531 10.9 77.4211 10.484L78.9931 10.412C79.0491 10.748 79.1891 11.008 79.4131 11.192C79.6371 11.376 79.9691 11.468 80.4091 11.468C80.7691 11.468 81.0491 11.412 81.2491 11.3C81.4571 11.18 81.5611 10.996 81.5611 10.748C81.5611 10.604 81.5251 10.484 81.4531 10.388C81.3811 10.292 81.2451 10.208 81.0451 10.136C80.8451 10.064 80.5491 9.992 80.1571 9.92C79.5011 9.808 78.9851 9.672 78.6091 9.512C78.2331 9.344 77.9651 9.136 77.8051 8.888C77.6531 8.64 77.5771 8.332 77.5771 7.964C77.5771 7.364 77.8051 6.88 78.2611 6.512C78.7251 6.136 79.4011 5.948 80.2891 5.948C80.8651 5.948 81.3491 6.044 81.7411 6.236C82.1331 6.42 82.4371 6.676 82.6531 7.004C82.8771 7.324 83.0171 7.692 83.0731 8.108L81.5251 8.18C81.4851 7.964 81.4131 7.776 81.3091 7.616C81.2051 7.456 81.0651 7.336 80.8891 7.256C80.7131 7.168 80.5051 7.124 80.2651 7.124C79.9051 7.124 79.6331 7.196 79.4491 7.34C79.2651 7.484 79.1731 7.676 79.1731 7.916C79.1731 8.084 79.2131 8.224 79.2931 8.336C79.3811 8.448 79.5211 8.54 79.7131 8.612C79.9051 8.676 80.1611 8.736 80.4811 8.792C81.1531 8.896 81.6811 9.032 82.0651 9.2C82.4571 9.36 82.7331 9.568 82.8931 9.824C83.0611 10.072 83.1451 10.372 83.1451 10.724C83.1451 11.132 83.0291 11.48 82.7971 11.768C82.5731 12.056 82.2531 12.276 81.8371 12.428C81.4291 12.572 80.9491 12.644 80.3971 12.644Z'
        fill='#2C8450'
      />
    </svg>
  )
}

export function RightPanelCloseIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5837 12.4998L4.92676 6.84292L6.34097 5.42871L11.9979 11.0856L17.6548 5.42871L19.069 6.84292L13.4121 12.4998L19.0689 18.1566L17.6547 19.5708L11.9979 13.914L6.34108 19.5708L4.92686 18.1566L10.5837 12.4998Z'
        fill='#161513'
      />
    </svg>
  )
}

export function NoRepoIcon({ className }: Props) {
  return (
    <svg
      width='308'
      height='24'
      viewBox='0 0 308 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M162.625 2.625H145.375C144.96 2.625 144.625 2.96016 144.625 3.375V20.625C144.625 21.0398 144.96 21.375 145.375 21.375H162.625C163.04 21.375 163.375 21.0398 163.375 20.625V3.375C163.375 2.96016 163.04 2.625 162.625 2.625ZM161.688 19.6875H146.312V4.3125H161.688V19.6875Z'
        fill='url(#paint0_linear_985_62342)'
      />
      <path
        opacity='0.1'
        d='M146.312 19.6875H161.688V4.3125H146.312V19.6875ZM149.5 11.4375C149.5 11.3344 149.584 11.25 149.688 11.25H158.312C158.416 11.25 158.5 11.3344 158.5 11.4375V12.5625C158.5 12.6656 158.416 12.75 158.312 12.75H149.688C149.584 12.75 149.5 12.6656 149.5 12.5625V11.4375Z'
        fill='#D9D9D9'
      />
      <path
        d='M149.688 12.75H158.312C158.416 12.75 158.5 12.6656 158.5 12.5625V11.4375C158.5 11.3344 158.416 11.25 158.312 11.25H149.688C149.584 11.25 149.5 11.3344 149.5 11.4375V12.5625C149.5 12.6656 149.584 12.75 149.688 12.75Z'
        fill='#D9D9D9'
      />
      <defs>
        <linearGradient
          id='paint0_linear_985_62342'
          x1='144.625'
          y1='12'
          x2='163.375'
          y2='12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function ConnectRepoContentIcon({ className }: Props) {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M15.85 15.5998L12.25 19.1998L8.65002 15.5998M8.65002 8.3998L12.25 4.7998L15.85 8.3998'
        stroke='black'
        strokeOpacity='0.45'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function InputNeededIcon({ className }: Props) {
  return (
    <svg
      width='103'
      height='22'
      viewBox='0 0 103 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H95C99.4183 0 103 3.58172 103 8V14C103 18.4183 99.4183 22 95 22H8C3.58172 22 0 18.4183 0 14V8Z'
        fill='#FFE7BA'
      />
      <path
        d='M8.912 15V13.632H10.856V7.848H8.912V6.48H14.288V7.848H12.344V13.632H14.288V15H8.912ZM16.1073 15V8.592H17.4033L17.4513 10.308L17.3073 10.224C17.3793 9.816 17.5153 9.484 17.7153 9.228C17.9153 8.964 18.1593 8.768 18.4473 8.64C18.7433 8.512 19.0633 8.448 19.4073 8.448C19.8793 8.448 20.2673 8.552 20.5713 8.76C20.8753 8.968 21.1033 9.256 21.2553 9.624C21.4073 9.984 21.4833 10.396 21.4833 10.86V15H20.0673V11.196C20.0673 10.684 19.9713 10.3 19.7793 10.044C19.5953 9.788 19.3113 9.66 18.9273 9.66C18.6713 9.66 18.4353 9.72 18.2193 9.84C18.0113 9.96 17.8433 10.14 17.7153 10.38C17.5873 10.612 17.5233 10.9 17.5233 11.244V15H16.1073ZM23.1586 16.8V8.592H24.5146L24.5506 10.056L24.4066 9.984C24.5666 9.488 24.8226 9.108 25.1746 8.844C25.5346 8.58 25.9666 8.448 26.4706 8.448C27.0626 8.448 27.5506 8.6 27.9346 8.904C28.3266 9.208 28.6146 9.612 28.7986 10.116C28.9906 10.62 29.0866 11.18 29.0866 11.796C29.0866 12.412 28.9906 12.972 28.7986 13.476C28.6146 13.98 28.3266 14.384 27.9346 14.688C27.5506 14.992 27.0626 15.144 26.4706 15.144C26.1426 15.144 25.8386 15.092 25.5586 14.988C25.2866 14.876 25.0506 14.72 24.8506 14.52C24.6586 14.312 24.5146 14.056 24.4186 13.752L24.5746 13.584V16.8H23.1586ZM26.1106 13.872C26.5826 13.872 26.9506 13.7 27.2146 13.356C27.4786 13.004 27.6106 12.484 27.6106 11.796C27.6106 11.108 27.4786 10.592 27.2146 10.248C26.9506 9.896 26.5826 9.72 26.1106 9.72C25.8066 9.72 25.5386 9.796 25.3066 9.948C25.0826 10.1 24.9026 10.332 24.7666 10.644C24.6386 10.948 24.5746 11.332 24.5746 11.796C24.5746 12.26 24.6386 12.648 24.7666 12.96C24.8946 13.264 25.0746 13.492 25.3066 13.644C25.5386 13.796 25.8066 13.872 26.1106 13.872ZM32.5379 15.144C31.9219 15.144 31.4339 14.94 31.0739 14.532C30.7219 14.116 30.5459 13.528 30.5459 12.768V8.592H31.9619V12.396C31.9619 12.932 32.0499 13.324 32.2259 13.572C32.4099 13.812 32.6859 13.932 33.0539 13.932C33.4379 13.932 33.7499 13.796 33.9899 13.524C34.2379 13.244 34.3619 12.852 34.3619 12.348V8.592H35.7899V15H34.4699L34.4459 13.236L34.6259 13.296C34.5219 13.888 34.2899 14.344 33.9299 14.664C33.5699 14.984 33.1059 15.144 32.5379 15.144ZM41.2813 15C40.5933 15 40.0853 14.844 39.7573 14.532C39.4293 14.212 39.2653 13.728 39.2653 13.08V7.092H40.6813V12.972C40.6813 13.268 40.7533 13.488 40.8973 13.632C41.0413 13.776 41.2533 13.848 41.5333 13.848H43.1172V15H41.2813ZM37.3333 9.744V8.592H43.1172V9.744H37.3333ZM51.9639 15V6.48H53.5599L56.1399 12.6V6.48H57.5799V15H55.9839L53.4039 8.88V15H51.9639ZM62.0272 15.144C61.4272 15.144 60.8992 15.008 60.4432 14.736C59.9952 14.464 59.6472 14.076 59.3992 13.572C59.1512 13.068 59.0272 12.476 59.0272 11.796C59.0272 11.124 59.1512 10.54 59.3992 10.044C59.6472 9.54 59.9912 9.148 60.4312 8.868C60.8792 8.588 61.4032 8.448 62.0032 8.448C62.5792 8.448 63.0872 8.584 63.5272 8.856C63.9752 9.128 64.3232 9.516 64.5712 10.02C64.8272 10.524 64.9552 11.124 64.9552 11.82V12.192H60.4912C60.5312 12.736 60.6872 13.152 60.9592 13.44C61.2392 13.728 61.6032 13.872 62.0512 13.872C62.3952 13.872 62.6792 13.792 62.9032 13.632C63.1352 13.464 63.2952 13.248 63.3832 12.984L64.8352 13.092C64.6352 13.732 64.2952 14.236 63.8152 14.604C63.3352 14.964 62.7392 15.144 62.0272 15.144ZM60.5032 11.16H63.4192C63.3792 10.672 63.2312 10.312 62.9752 10.08C62.7192 9.84 62.3912 9.72 61.9912 9.72C61.5912 9.72 61.2592 9.844 60.9952 10.092C60.7392 10.332 60.5752 10.688 60.5032 11.16ZM69.2225 15.144C68.6225 15.144 68.0945 15.008 67.6385 14.736C67.1905 14.464 66.8425 14.076 66.5945 13.572C66.3465 13.068 66.2225 12.476 66.2225 11.796C66.2225 11.124 66.3465 10.54 66.5945 10.044C66.8425 9.54 67.1865 9.148 67.6265 8.868C68.0745 8.588 68.5985 8.448 69.1985 8.448C69.7745 8.448 70.2825 8.584 70.7225 8.856C71.1705 9.128 71.5185 9.516 71.7665 10.02C72.0225 10.524 72.1505 11.124 72.1505 11.82V12.192H67.6865C67.7265 12.736 67.8825 13.152 68.1545 13.44C68.4345 13.728 68.7985 13.872 69.2465 13.872C69.5905 13.872 69.8745 13.792 70.0985 13.632C70.3305 13.464 70.4905 13.248 70.5785 12.984L72.0305 13.092C71.8305 13.732 71.4905 14.236 71.0105 14.604C70.5305 14.964 69.9345 15.144 69.2225 15.144ZM67.6985 11.16H70.6145C70.5745 10.672 70.4265 10.312 70.1705 10.08C69.9145 9.84 69.5865 9.72 69.1865 9.72C68.7865 9.72 68.4545 9.844 68.1905 10.092C67.9345 10.332 67.7705 10.688 67.6985 11.16ZM75.7578 15.144C75.2218 15.144 74.7578 15.012 74.3658 14.748C73.9738 14.476 73.6698 14.092 73.4538 13.596C73.2458 13.092 73.1418 12.492 73.1418 11.796C73.1418 11.1 73.2458 10.504 73.4538 10.008C73.6698 9.504 73.9738 9.12 74.3658 8.856C74.7578 8.584 75.2218 8.448 75.7578 8.448C76.2058 8.448 76.5938 8.552 76.9218 8.76C77.2578 8.96 77.5018 9.204 77.6538 9.492V6.48H79.0698V15H77.7258L77.6898 14.004C77.5218 14.34 77.2698 14.616 76.9338 14.832C76.6058 15.04 76.2138 15.144 75.7578 15.144ZM76.0938 13.872C76.4058 13.872 76.6778 13.788 76.9098 13.62C77.1498 13.452 77.3338 13.216 77.4618 12.912C77.5898 12.6 77.6538 12.228 77.6538 11.796C77.6538 11.356 77.5898 10.984 77.4618 10.68C77.3338 10.368 77.1498 10.132 76.9098 9.972C76.6778 9.804 76.3978 9.72 76.0698 9.72C75.6138 9.72 75.2578 9.904 75.0018 10.272C74.7458 10.632 74.6178 11.14 74.6178 11.796C74.6178 12.452 74.7458 12.964 75.0018 13.332C75.2578 13.692 75.6218 13.872 76.0938 13.872ZM83.6131 15.144C83.0131 15.144 82.4851 15.008 82.0291 14.736C81.5811 14.464 81.2331 14.076 80.9851 13.572C80.7371 13.068 80.6131 12.476 80.6131 11.796C80.6131 11.124 80.7371 10.54 80.9851 10.044C81.2331 9.54 81.5771 9.148 82.0171 8.868C82.4651 8.588 82.9891 8.448 83.5891 8.448C84.1651 8.448 84.6731 8.584 85.1131 8.856C85.5611 9.128 85.9091 9.516 86.1571 10.02C86.4131 10.524 86.5411 11.124 86.5411 11.82V12.192H82.0771C82.1171 12.736 82.2731 13.152 82.5451 13.44C82.8251 13.728 83.1891 13.872 83.6371 13.872C83.9811 13.872 84.2651 13.792 84.4891 13.632C84.7211 13.464 84.8811 13.248 84.9691 12.984L86.4211 13.092C86.2211 13.732 85.8811 14.236 85.4011 14.604C84.9211 14.964 84.3251 15.144 83.6131 15.144ZM82.0891 11.16H85.0051C84.9651 10.672 84.8171 10.312 84.5611 10.08C84.3051 9.84 83.9771 9.72 83.5771 9.72C83.1771 9.72 82.8451 9.844 82.5811 10.092C82.3251 10.332 82.1611 10.688 82.0891 11.16ZM90.1484 15.144C89.6124 15.144 89.1484 15.012 88.7564 14.748C88.3644 14.476 88.0604 14.092 87.8444 13.596C87.6364 13.092 87.5324 12.492 87.5324 11.796C87.5324 11.1 87.6364 10.504 87.8444 10.008C88.0604 9.504 88.3644 9.12 88.7564 8.856C89.1484 8.584 89.6124 8.448 90.1484 8.448C90.5964 8.448 90.9844 8.552 91.3124 8.76C91.6484 8.96 91.8924 9.204 92.0444 9.492V6.48H93.4604V15H92.1164L92.0804 14.004C91.9124 14.34 91.6604 14.616 91.3244 14.832C90.9964 15.04 90.6044 15.144 90.1484 15.144ZM90.4844 13.872C90.7964 13.872 91.0684 13.788 91.3004 13.62C91.5404 13.452 91.7244 13.216 91.8524 12.912C91.9804 12.6 92.0444 12.228 92.0444 11.796C92.0444 11.356 91.9804 10.984 91.8524 10.68C91.7244 10.368 91.5404 10.132 91.3004 9.972C91.0684 9.804 90.7884 9.72 90.4604 9.72C90.0044 9.72 89.6484 9.904 89.3924 10.272C89.1364 10.632 89.0084 11.14 89.0084 11.796C89.0084 12.452 89.1364 12.964 89.3924 13.332C89.6484 13.692 90.0124 13.872 90.4844 13.872Z'
        fill='black'
        fillOpacity='0.88'
      />
    </svg>
  )
}

export function ResultCardFooterIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3688_18838)'>
        <path
          d='M17.031 12.5306L9.53104 20.0306C9.46136 20.1002 9.37863 20.1555 9.28759 20.1932C9.19654 20.2309 9.09896 20.2503 9.00042 20.2503C8.90187 20.2503 8.80429 20.2309 8.71324 20.1932C8.6222 20.1555 8.53947 20.1002 8.46979 20.0306C8.40011 19.9609 8.34483 19.8781 8.30712 19.7871C8.26941 19.6961 8.25 19.5985 8.25 19.4999C8.25 19.4014 8.26941 19.3038 8.30712 19.2128C8.34483 19.1217 8.40011 19.039 8.46979 18.9693L15.4401 11.9999L8.46979 5.03055C8.32906 4.88982 8.25 4.69895 8.25 4.49993C8.25 4.30091 8.32906 4.11003 8.46979 3.9693C8.61052 3.82857 8.80139 3.74951 9.00042 3.74951C9.19944 3.74951 9.39031 3.82857 9.53104 3.9693L17.031 11.4693C17.1008 11.539 17.1561 11.6217 17.1938 11.7127C17.2316 11.8038 17.251 11.9014 17.251 11.9999C17.251 12.0985 17.2316 12.1961 17.1938 12.2871C17.1561 12.3782 17.1008 12.4609 17.031 12.5306Z'
          fill='url(#paint0_linear_3688_18838)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_3688_18838'
          x1='8.25'
          y1='11.9999'
          x2='17.251'
          y2='11.9999'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <clipPath id='clip0_3688_18838'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export function DeleteWorkspaceIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12.75 17.0625C12.75 17.1656 12.6656 17.25 12.5625 17.25H11.4375C11.3344 17.25 11.25 17.1656 11.25 17.0625V10.6875C11.25 10.5844 11.3344 10.5 11.4375 10.5H12.5625C12.6656 10.5 12.75 10.5844 12.75 10.6875V17.0625ZM12 9C11.7056 8.99399 11.4253 8.87282 11.2192 8.6625C11.0132 8.45218 10.8977 8.16945 10.8977 7.875C10.8977 7.58055 11.0132 7.29782 11.2192 7.0875C11.4253 6.87718 11.7056 6.75601 12 6.75C12.2944 6.75601 12.5747 6.87718 12.7808 7.0875C12.9868 7.29782 13.1023 7.58055 13.1023 7.875C13.1023 8.16945 12.9868 8.45218 12.7808 8.6625C12.5747 8.87282 12.2944 8.99399 12 9Z'
        fill='#EA462D'
      />
    </svg>
  )
}

export function GrayGear({ className }: Props) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_2764_937)'>
        <path
          d='M10 6.25004C9.25833 6.25004 8.5333 6.46997 7.91662 6.88203C7.29993 7.29408 6.81929 7.87975 6.53546 8.56497C6.25163 9.2502 6.17737 10.0042 6.32206 10.7316C6.46676 11.4591 6.82391 12.1272 7.34836 12.6517C7.8728 13.1761 8.54099 13.5333 9.26842 13.678C9.99585 13.8227 10.7498 13.7484 11.4351 13.4646C12.1203 13.1808 12.706 12.7001 13.118 12.0834C13.5301 11.4667 13.75 10.7417 13.75 10C13.749 9.00579 13.3536 8.05257 12.6505 7.34953C11.9475 6.64649 10.9943 6.25107 10 6.25004ZM10 12.5C9.50555 12.5 9.0222 12.3534 8.61108 12.0787C8.19996 11.804 7.87953 11.4136 7.69031 10.9567C7.50109 10.4999 7.45158 9.99726 7.54804 9.51231C7.64451 9.02736 7.88261 8.5819 8.23224 8.23227C8.58187 7.88264 9.02733 7.64454 9.51228 7.54807C9.99723 7.45161 10.4999 7.50112 10.9567 7.69034C11.4135 7.87956 11.804 8.19999 12.0787 8.61111C12.3534 9.02223 12.5 9.50558 12.5 10C12.5 10.6631 12.2366 11.299 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5ZM16.875 10.1688C16.8781 10.0563 16.8781 9.94379 16.875 9.83129L18.0406 8.37504C18.1017 8.29858 18.1441 8.20883 18.1641 8.11303C18.1842 8.01722 18.1815 7.91804 18.1563 7.82347C17.9652 7.10519 17.6793 6.41554 17.3063 5.77269C17.2574 5.68857 17.1896 5.617 17.1082 5.5637C17.0268 5.5104 16.9341 5.47683 16.8375 5.46566L14.9844 5.25941C14.9073 5.17816 14.8292 5.10004 14.75 5.02504L14.5313 3.16722C14.52 3.07051 14.4863 2.97777 14.4329 2.89639C14.3794 2.815 14.3077 2.74723 14.2234 2.69847C13.5803 2.32609 12.8908 2.04053 12.1727 1.84925C12.078 1.8241 11.9788 1.82152 11.883 1.84174C11.7872 1.86196 11.6975 1.90441 11.6211 1.96566L10.1688 3.12504C10.0563 3.12504 9.94376 3.12504 9.83126 3.12504L8.37501 1.96175C8.29855 1.90064 8.2088 1.85833 8.113 1.83825C8.01719 1.81816 7.91801 1.82086 7.82344 1.84613C7.10528 2.03756 6.41567 2.32338 5.77266 2.69613C5.68853 2.74498 5.61697 2.81279 5.56367 2.89417C5.51037 2.97555 5.4768 3.06824 5.46563 3.16488L5.25938 5.02113C5.17813 5.09873 5.10001 5.17686 5.02501 5.2555L3.16719 5.46879C3.07048 5.48004 2.97774 5.51373 2.89636 5.56717C2.81497 5.62061 2.7472 5.69233 2.69844 5.7766C2.32606 6.4197 2.0405 7.10929 1.84922 7.82738C1.82407 7.92201 1.82149 8.02122 1.84171 8.11703C1.86193 8.21284 1.90438 8.30255 1.96563 8.37894L3.12501 9.83129C3.12501 9.94379 3.12501 10.0563 3.12501 10.1688L1.96172 11.625C1.90061 11.7015 1.8583 11.7912 1.83822 11.887C1.81813 11.9828 1.82083 12.082 1.8461 12.1766C2.03718 12.8949 2.32303 13.5845 2.6961 14.2274C2.74495 14.3115 2.81276 14.3831 2.89414 14.4364C2.97551 14.4897 3.06821 14.5232 3.16485 14.5344L5.01797 14.7407C5.09558 14.8219 5.1737 14.9 5.25235 14.975L5.46876 16.8329C5.48001 16.9296 5.5137 17.0223 5.56714 17.1037C5.62058 17.1851 5.6923 17.2528 5.77657 17.3016C6.41967 17.674 7.10926 17.9595 7.82735 18.1508C7.92198 18.176 8.02119 18.1786 8.117 18.1583C8.21281 18.1381 8.30252 18.0957 8.37891 18.0344L9.83126 16.875C9.94376 16.8782 10.0563 16.8782 10.1688 16.875L11.625 18.0407C11.7015 18.1018 11.7912 18.1441 11.887 18.1642C11.9828 18.1843 12.082 18.1816 12.1766 18.1563C12.8948 17.9652 13.5845 17.6794 14.2274 17.3063C14.3115 17.2574 14.383 17.1896 14.4363 17.1082C14.4896 17.0269 14.5232 16.9342 14.5344 16.8375L14.7406 14.9844C14.8219 14.9073 14.9 14.8292 14.975 14.75L16.8328 14.5313C16.9295 14.52 17.0223 14.4863 17.1037 14.4329C17.185 14.3795 17.2528 14.3077 17.3016 14.2235C17.674 13.5804 17.9595 12.8908 18.1508 12.1727C18.1759 12.0781 18.1785 11.9788 18.1583 11.883C18.1381 11.7872 18.0956 11.6975 18.0344 11.6211L16.875 10.1688ZM15.6172 9.66097C15.6305 9.88682 15.6305 10.1133 15.6172 10.3391C15.6079 10.4937 15.6563 10.6463 15.7531 10.7672L16.8617 12.1524C16.7345 12.5567 16.5716 12.9488 16.375 13.3243L14.6094 13.5243C14.4556 13.5413 14.3137 13.6148 14.2109 13.7305C14.0606 13.8996 13.9004 14.0598 13.7313 14.2102C13.6156 14.3129 13.5421 14.4549 13.525 14.6086L13.3289 16.3727C12.9535 16.5694 12.5613 16.7323 12.157 16.8594L10.7711 15.7508C10.6602 15.6622 10.5224 15.614 10.3805 15.6141H10.343C10.1171 15.6274 9.8907 15.6274 9.66485 15.6141C9.51023 15.6048 9.35766 15.6532 9.23672 15.75L7.84766 16.8594C7.44339 16.7322 7.05122 16.5693 6.67579 16.3727L6.47579 14.6094C6.45872 14.4557 6.38523 14.3137 6.26954 14.211C6.1004 14.0606 5.94023 13.9004 5.78985 13.7313C5.68714 13.6156 5.54517 13.5421 5.39141 13.525L3.62735 13.3282C3.43062 12.9528 3.26774 12.5606 3.14063 12.1563L4.24922 10.7703C4.34603 10.6494 4.39447 10.4968 4.38516 10.3422C4.37188 10.1164 4.37188 9.88995 4.38516 9.6641C4.39447 9.50948 4.34603 9.35691 4.24922 9.23597L3.14063 7.84769C3.26784 7.44342 3.43072 7.05125 3.62735 6.67582L5.39063 6.47582C5.54439 6.45875 5.68636 6.38526 5.78907 6.26957C5.93945 6.10043 6.09962 5.94026 6.26876 5.78988C6.38491 5.6871 6.4587 5.54481 6.47579 5.39066L6.67188 3.62738C7.04727 3.43065 7.43945 3.26777 7.84376 3.14066L9.22969 4.24925C9.35063 4.34606 9.5032 4.3945 9.65782 4.38519C9.88367 4.37191 10.1101 4.37191 10.3359 4.38519C10.4906 4.3945 10.6431 4.34606 10.7641 4.24925L12.1524 3.14066C12.5566 3.26787 12.9488 3.43075 13.3242 3.62738L13.5242 5.39066C13.5413 5.54442 13.6148 5.68639 13.7305 5.7891C13.8996 5.93948 14.0598 6.09965 14.2102 6.26879C14.3129 6.38448 14.4548 6.45797 14.6086 6.47504L16.3727 6.67113C16.5694 7.04652 16.7323 7.4387 16.8594 7.84301L15.7508 9.22894C15.6531 9.35089 15.6046 9.50503 15.6149 9.66097H15.6172Z'
          fill='black'
          fillOpacity='0.45'
        />
      </g>
      <defs>
        <clipPath id='clip0_2764_937'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ToaskCheckCircleIcon({ className }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12ZM17.7071 9.20711L16.2929 7.79289L10.5 13.5858L8.20711 11.2929L6.79289 12.7071L10.5 16.4142L17.7071 9.20711Z'
        fill='white'
      />
    </svg>
  )
}

export function XmlFileUploadedLeftIcon({ className }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.75 5.0625V15.75C15.75 16.3467 15.5129 16.919 15.091 17.341C14.669 17.7629 14.0967 18 13.5 18V16.875C13.7984 16.875 14.0845 16.7565 14.2955 16.5455C14.5065 16.3345 14.625 16.0484 14.625 15.75V5.0625H12.375C11.9274 5.0625 11.4982 4.88471 11.1818 4.56824C10.8653 4.25178 10.6875 3.82255 10.6875 3.375V1.125H4.5C4.20163 1.125 3.91548 1.24353 3.7045 1.4545C3.49353 1.66548 3.375 1.95163 3.375 2.25V12.375H2.25V2.25C2.25 1.65326 2.48705 1.08097 2.90901 0.65901C3.33097 0.237053 3.90326 0 4.5 0L10.6875 0L15.75 5.0625ZM3.96788 13.3313H2.96325L2.03737 14.9501H1.99687L1.06088 13.3313H0.0135L1.39388 15.5621L0 17.8313H0.968625L1.92825 16.2394H1.96762L2.92387 17.8313H3.94537L2.53463 15.5903L3.96788 13.3324V13.3313ZM5.04112 17.8301V14.8376H5.08388L6.15488 17.2665H6.73537L7.79962 14.8365H7.84238V17.8301H8.64675V13.3313H7.74675L6.46425 16.2518H6.43613L5.1525 13.3313H4.24575V17.8301H5.04H5.04112ZM10.3399 17.0719H12.2479V17.8301H9.45V13.3313H10.3399V17.0719Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export function XmlFileUploadLeftIcon({ className }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
    >
      <path
        d='M8.25 12V5.8875L6.3 7.8375L5.25 6.75L9 3L12.75 6.75L11.7 7.8375L9.75 5.8875V12H8.25ZM4.5 15C4.0875 15 3.73438 14.8531 3.44063 14.5594C3.14688 14.2656 3 13.9125 3 13.5V11.25H4.5V13.5H13.5V11.25H15V13.5C15 13.9125 14.8531 14.2656 14.5594 14.5594C14.2656 14.8531 13.9125 15 13.5 15H4.5Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function RedDeleteIcon({ className }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
    >
      <path
        d='M6.32812 3.23438H6.1875C6.26484 3.23438 6.32812 3.17109 6.32812 3.09375V3.23438H11.6719V3.09375C11.6719 3.17109 11.7352 3.23438 11.8125 3.23438H11.6719V4.5H12.9375V3.09375C12.9375 2.47324 12.433 1.96875 11.8125 1.96875H6.1875C5.56699 1.96875 5.0625 2.47324 5.0625 3.09375V4.5H6.32812V3.23438ZM15.1875 4.5H2.8125C2.50137 4.5 2.25 4.75137 2.25 5.0625V5.625C2.25 5.70234 2.31328 5.76562 2.39062 5.76562H3.45234L3.88652 14.959C3.91465 15.5584 4.41035 16.0312 5.00977 16.0312H12.9902C13.5914 16.0312 14.0854 15.5602 14.1135 14.959L14.5477 5.76562H15.6094C15.6867 5.76562 15.75 5.70234 15.75 5.625V5.0625C15.75 4.75137 15.4986 4.5 15.1875 4.5ZM12.8549 14.7656H5.14512L4.71973 5.76562H13.2803L12.8549 14.7656Z'
        fill='#D94B36'
      />
    </svg>
  )
}

export function CodeFileIcon({ className }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M17.0306 13.7194C17.1004 13.789 17.1557 13.8717 17.1934 13.9628C17.2312 14.0538 17.2506 14.1514 17.2506 14.25C17.2506 14.3486 17.2312 14.4462 17.1934 14.5372C17.1557 14.6283 17.1004 14.711 17.0306 14.7806L14.7806 17.0306C14.6399 17.1714 14.449 17.2504 14.25 17.2504C14.051 17.2504 13.8601 17.1714 13.7194 17.0306C13.5786 16.8899 13.4996 16.699 13.4996 16.5C13.4996 16.301 13.5786 16.1101 13.7194 15.9694L15.4397 14.25L13.7194 12.5306C13.5786 12.3899 13.4996 12.199 13.4996 12C13.4996 11.801 13.5786 11.6101 13.7194 11.4694C13.8601 11.3286 14.051 11.2496 14.25 11.2496C14.449 11.2496 14.6399 11.3286 14.7806 11.4694L17.0306 13.7194ZM10.2806 11.4694C10.211 11.3996 10.1283 11.3443 10.0372 11.3066C9.94616 11.2688 9.84856 11.2494 9.75 11.2494C9.65144 11.2494 9.55384 11.2688 9.46279 11.3066C9.37175 11.3443 9.28903 11.3996 9.21937 11.4694L6.96937 13.7194C6.89964 13.789 6.84432 13.8717 6.80658 13.9628C6.76884 14.0538 6.74941 14.1514 6.74941 14.25C6.74941 14.3486 6.76884 14.4462 6.80658 14.5372C6.84432 14.6283 6.89964 14.711 6.96937 14.7806L9.21937 17.0306C9.28906 17.1003 9.37178 17.1556 9.46283 17.1933C9.55387 17.231 9.65145 17.2504 9.75 17.2504C9.84855 17.2504 9.94613 17.231 10.0372 17.1933C10.1282 17.1556 10.2109 17.1003 10.2806 17.0306C10.3503 16.9609 10.4056 16.8782 10.4433 16.7872C10.481 16.6961 10.5004 16.5985 10.5004 16.5C10.5004 16.4015 10.481 16.3039 10.4433 16.2128C10.4056 16.1218 10.3503 16.0391 10.2806 15.9694L8.56031 14.25L10.2806 12.5306C10.3504 12.461 10.4057 12.3783 10.4434 12.2872C10.4812 12.1962 10.5006 12.0986 10.5006 12C10.5006 11.9014 10.4812 11.8038 10.4434 11.7128C10.4057 11.6217 10.3504 11.539 10.2806 11.4694ZM20.25 8.25V20.25C20.25 20.6478 20.092 21.0294 19.8107 21.3107C19.5294 21.592 19.1478 21.75 18.75 21.75H5.25C4.85218 21.75 4.47064 21.592 4.18934 21.3107C3.90804 21.0294 3.75 20.6478 3.75 20.25V3.75C3.75 3.35218 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25H14.25C14.3485 2.24992 14.4461 2.26926 14.5371 2.3069C14.6282 2.34454 14.7109 2.39975 14.7806 2.46938L20.0306 7.71938C20.1003 7.78908 20.1555 7.87182 20.1931 7.96286C20.2307 8.05391 20.2501 8.15148 20.25 8.25ZM15 7.5H17.6897L15 4.81031V7.5ZM18.75 20.25V9H14.25C14.0511 9 13.8603 8.92098 13.7197 8.78033C13.579 8.63968 13.5 8.44891 13.5 8.25V3.75H5.25V20.25H18.75Z'
        fill='currentColor'
      />
    </svg>
  )
}

export function WarningIcon({ className }: Props) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12.75 17.0625C12.75 17.1656 12.6656 17.25 12.5625 17.25H11.4375C11.3344 17.25 11.25 17.1656 11.25 17.0625V10.6875C11.25 10.5844 11.3344 10.5 11.4375 10.5H12.5625C12.6656 10.5 12.75 10.5844 12.75 10.6875V17.0625ZM12 9C11.7056 8.99399 11.4253 8.87282 11.2192 8.6625C11.0132 8.45218 10.8977 8.16945 10.8977 7.875C10.8977 7.58055 11.0132 7.29782 11.2192 7.0875C11.4253 6.87718 11.7056 6.75601 12 6.75C12.2944 6.75601 12.5747 6.87718 12.7808 7.0875C12.9868 7.29782 13.1023 7.58055 13.1023 7.875C13.1023 8.16945 12.9868 8.45218 12.7808 8.6625C12.5747 8.87282 12.2944 8.99399 12 9Z'
        fill='#D94B36'
      />
    </svg>
  )
}
